<template>
  <div id="settingContainer" class="page-container">
    <div class="page-content">
      <div v-if="setingChanged" class="warning-popup">
        <div class="body flex-center" style="width: 430px">
          <div class="fs-500 fc-FFFFFF fs-14">
            {{ $t('settings.changes_banner') }}
          </div>
          <div @click="undoSaveSetting" class="cursor-pointer ml-auto undo-bottom flex-mid">
            {{ $t('settings.undo') }}
          </div>
          <div @click="saveChanges" class="cursor-pointer save-bottom flex-mid">
            {{ $t('settings.save_changes') }}
          </div>
        </div>
      </div>
      <div class="flex-row-center mt-16">
        <img @click.prevent="refresh" src="../assets/images/navbar/ic_settings.webp" class="icon-pages" />
        <span class="page-title">{{ $t('settings.page_title') }}</span>
        <div class="page-des page-des-line-button">
          {{ $t('settings.page_description') }}
        </div>
        <div class="button-title">
          <el-button
            class="btnAddSettings"
            :class="{ 'btnAddSettings--dirty': setingChanged }"
            type="primary"
            :disabled="!setingChanged"
            @click="saveChanges">{{ $t('settings.save_changes') }}</el-button>
        </div>
      </div>

      <div class="div-page-content flex-column mt-32 relative">
        <el-tabs class="styleTab" v-model="activeTab">
          <el-tab-pane name="general">
            <span slot="label" class="title-bar">{{ $t('settings.tab_general') }}</span>
            <!-- General Settings Tab -->
            <el-form class="margin-subpages">
              <div id="generalSettings">
                <span class="sub-title">{{ $t('settings.section_general') }}</span>
                <p class="settings-tab-description">
                  {{ $t('settings.section_general_description') }}
                </p>
                <div class="line-style mt-20" />
                <div style="margin-top: 32px; margin-right: 100px">
                  <el-form-item style="margin-bottom: 16px">
                    <span slot="label" class="inputLabelStyle">{{ $t('settings.company_name') }}</span>
                    <el-input disabled class="inputReportStyle" 
                    v-model="user.company_name" :class="[ blurMode ?  'blurelement': '' ]"></el-input>
                  </el-form-item>
                </div>
                <div style="margin-top: 32px; margin-right: 100px">
                  <div>
                    <div class="header-text">{{ $t('settings.pulse_report_schedule') }}</div>
                    <span class="description-text">{{ $t('settings.pulse_report_schedule_description') }}</span>
                  </div>
                </div>
                <div id="formReport" class="mx-2 mt-32 grid-2-50">
                  <div>
                    <el-form-item style="margin-bottom: 16px" prop="date1" v-if="settingData.gen_question == 'Y'">
                      <span slot="label" class="inputLabelStyle">{{ $t('settings.daily_pulse') }}</span>
                      <el-time-picker :picker-options="{ selectableRange: '05:00:00 - 15:00:00' }" format="h:mm A"
                        value-format="h:mm A" class="inputReportStyle" type="fixed-time" v-model="settingData.starttime"
                        placement="bottom-start"></el-time-picker>
                      <span style="
                          pointer-events: none;
                          font-size: 18px;
                          color: #b5b5b5;
                          position: absolute;
                          left: 207px;
                          top: 6px;
                        ">Mon - Fri</span>
                    </el-form-item>

                    <el-form-item style="margin-bottom: 16px" prop="date3" v-if="settingData.report_dailyboss == 'Y'">
                      <span slot="label" class="inputLabelStyle">{{ $t('settings.daily_insights') }}</span>
                      <el-time-picker :picker-options="{ selectableRange: '05:00:00 - 14:00:00' }" format="h:mm A"
                        value-format="h:mm A" class="inputReportStyle" type="fixed-time"
                        v-model="settingData.report_dailyboss_time" placement="bottom-start"></el-time-picker>
                      <span style="
                          pointer-events: none;
                          font-size: 18px;
                          color: #b5b5b5;
                          position: absolute;
                          left: 207px;
                          top: 6px;
                        ">Tue - Sat</span>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item prop="date4" v-if="settingData.report_weeklyboss == 'Y'">
                      <span slot="label" class="inputLabelStyle">{{ $t('settings.weekly_insights') }}</span>
                      <el-time-picker :picker-options="{ selectableRange: '05:00:00 - 14:00:00' }" format="h:mm A"
                        value-format="h:mm A" class="inputReportStyle" type="fixed-time"
                        v-model="settingData.report_weeklyboss_time" placement="bottom-start"></el-time-picker>
                      <span style="
                          pointer-events: none;
                          font-size: 18px;
                          color: #b5b5b5;
                          position: absolute;
                          left: 207px;
                          top: 6px;
                        ">Monday</span>
                    </el-form-item>
                    <el-form-item prop="date4" v-if="settingData.report_monthly_insights == 'Y'">
                      <span slot="label" class="inputLabelStyle">{{ $t('settings.monthly_insights') }}</span>
                      <el-time-picker :picker-options="{ selectableRange: '05:00:00 - 16:00:00' }" format="h:mm A"
                        value-format="h:mm A" class="inputReportStyle" type="fixed-time"
                        v-model="settingData.report_monthlyboss_time" placement="bottom-start"></el-time-picker>
                      <span style="
                          pointer-events: none;
                          font-size: 18px;
                          color: #b5b5b5;
                          position: absolute;
                          left: 207px;
                          top: 6px;
                        ">1st of Mo</span>
                    </el-form-item>
                  </div>
                </div>

                <div style="margin-top: 32px; margin-right: 100px">
                  <div>
                    <div class="header-text">{{ $t('settings.company_holidays') }}</div>
                    <span class="description-text">{{ $t('settings.company_holidays_description') }}</span>
                  </div>
                  <div v-if="settingData['holiday_tag'] &&
                    settingData['holiday_tag'].length > 0
                    " style="display: flex; flex-wrap: wrap; gap: 8px;" class="pt-12">
                    <div class="preset-date-tag" v-for="(item, index) in settingData['holiday_tag']" :key="item">
                      <i class="el-icon-date date-icon"></i>
                      <span>{{ item }}</span>
                      <i @click="removeTag(index)" class="el-icon-close"></i>
                    </div>
                  </div>
                  <div v-bind:style="'position: relative; padding-top: ' +
                    getPaddingStyle(settingData['holiday_tag'])
                    " v-if="settingData['holiday_val']">
                    <el-button style="width:200px;height:33px;background: #32C2D5;color: #FFFFFF;border: none;font-size: 14px;padding: 0px;" @click="showDatepickerHoliday">
                      <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                        <i class="el-icon-plus" style="font-size: 16px; font-weight: 700;"></i>
                        <span>{{ $t('settings.add_holidays') }}</span>
                      </div>
                    </el-button>
                    <el-date-picker :clearable="false" :editable="false" @change="confirmHolidayDatepicker"
                      class="dialogInputDatepicker" ref="datepicker_holiday" type="dates" v-model="settingData['holiday_val']"
                      placement="bottom-start" style="position: absolute; top: 0; left: 0; opacity: 0; pointer-events: none;"></el-date-picker>
                  </div>

                  <!-- Personal Holiday Presets Section -->
                  <div style="margin-top: 32px;">
                    <div>
                      <div class="header-text">{{ $t('settings.personal_holiday_presets') }}</div>
                      <span class="description-text">{{ $t('settings.personal_holiday_presets_description') }}</span>
                    </div>
                    <div style="margin-top: 16px;">
                      <el-button style="width:200px;height:33px;background: #32C2D5;color: #FFFFFF;border: none;font-size: 14px;padding: 0px;" @click="showModal_holiday_presets=true">
                        <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                          <i class="el-icon-plus" style="font-size: 16px; font-weight: 700;"></i>
                          <span>{{ $t('settings.set_personal_holiday') }}</span>
                        </div>
                      </el-button>
                      <div style="margin-top: 8px; font-size: 14px;">{{ presetlistAll?presetlistAll.length:0 }} Holiday Presets Active</div>
                    </div>
                  </div>
                </div>



                <div class="header-text mt-52">
                  <div class="header-text">{{ $t('settings.activity_feed_names') }}</div>
                  <div class="description-text">
                    {{ $t('settings.activity_feed_names_description') }}
                  </div>
                  <div class="flex-center mt-18">
                    <div class="switch mr-16">
                      <div class="can-toggle">
                        <input class="input" type="checkbox" id="activity_feed_use_nickname"
                          v-model="settingData.activity_feed_use_nickname" />
                        <label for="activity_feed_use_nickname" :class="`${settingData.activity_feed_use_nickname
                          ? 'power-on'
                          : 'power-off'
                          }`">
                          <div class="switch-body flex-mid">
                            <div v-if="settingData.activity_feed_use_nickname" class="mr-auto ml-14 mt-2">
                              ON
                            </div>
                            <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <span class="fc-4A4A4A fs-14 fw-700">{{ $t('settings.use_nicknames_in_activity_feed') }}</span>
                  </div>
                </div>

                <div class="header-text mt-52">
                  <div class="header-text">{{ $t('settings.activity_feed_rewards') }}</div>
                  <div class="description-text">
                    {{ $t('settings.activity_feed_rewards_description') }}
                  </div>
                  <div class="flex-center mt-18">
                    <div class="switch mr-16">
                      <div class="can-toggle">
                        <input class="input" type="checkbox" id="activity_feed_show_rewards"
                          v-model="settingData.activity_feed_show_rewards" />
                        <label for="activity_feed_show_rewards" :class="`${settingData.activity_feed_show_rewards
                          ? 'power-on'
                          : 'power-off'
                          }`">
                          <div class="switch-body flex-mid">
                            <div v-if="settingData.activity_feed_show_rewards" class="mr-auto ml-14 mt-2">
                              ON
                            </div>
                            <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <span class="fc-4A4A4A fs-14 fw-700">{{ $t('settings.show_reward_redemptions_in_activity_feed') }}</span>
                  </div>
                </div>

                <SettingsToggleRow
                  id="giftCrossLocationRewards_checked"
                  :title="$t('settings.allow_cross_location_gift_rewards')"
                  :description="$t('settings.allow_cross_location_gift_rewards_description')"
                  v-model="settingData.giftCrossLocationRewards_checked"
                />

                <div class="line-style mt-32" />
                <div class="header-text mt-52">
                  <div class="header-text">{{ $t('settings.happily_assistance') }}</div>
                  <div class="description-text">
                    {{ $t('settings.happily_assistance_description') }}
                  </div>
                  <div class="flex-center mt-18">
                    <div class="switch mr-16">
                      <div class="can-toggle">
                        <input class="input" type="checkbox" id="happilyAssistAccess_checked"
                          v-model="settingData.happilyAssistAccess_checked" />
                        <label for="happilyAssistAccess_checked" :class="`${settingData.happilyAssistAccess_checked
                          ? 'power-on'
                          : 'power-off'
                          }`">
                          <div class="switch-body flex-mid">
                            <div v-if="settingData.happilyAssistAccess_checked" class="mr-auto ml-14 mt-2">
                              ON
                            </div>
                            <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <span class="fc-4A4A4A fs-14 fw-700">{{ $t('settings.happily_assist_access') }}</span>
                  </div>
                </div>
                <div class="line-style mt-32" />
                <div class="header-text mt-24">{{ $t('settings.demo_mode') }}</div>
                <div class="description-text">
                  {{ $t('settings.demo_mode_description') }}
                </div>
                <div class="flex-center mt-18">
                  <div class="switch mr-16">
                    <div class="can-toggle">
                      <input class="input" type="checkbox" id="demoMode_checked"
                        :checked="blurMode" @change="toggleDemoMode" />
                      <label for="demoMode_checked" :class="blurMode ? 'power-on' : 'power-off'">
                        <div class="switch-body flex-mid">
                          <div v-if="blurMode" class="mr-auto ml-14 mt-2">ON</div>
                          <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <span class="fc-4A4A4A fs-14 fw-700">{{ $t('settings.enable_demo_mode') }}</span>
                </div>
                <div class="mt-24 fc-4A4A4A fs-14">Windows:
                  <span class="key">Ctrl</span> + <span class="key">Alt</span> + <span class="key">D</span> or
                  <span class="key">⊞</span> + <span class="key">Alt</span> + <span class="key">D</span>
                </div>
                <div class="mt-24 fc-4A4A4A fs-14">Mac: 
                  <span class="key">⌃</span> + <span class="key">⌥</span> + <span class="key">D</span> or
                  <span class="key">⌘</span> + <span class="key">⌥</span> + <span class="key">D</span>
                </div>
              </div>
            </el-form>
          </el-tab-pane>

          <el-tab-pane name="performance">
            <span slot="label" class="title-bar">{{ $t('settings.tab_performance') }}</span>
            <!-- Performance Reviews Tab -->
            <el-form class="margin-subpages">
              <div style="margin-top: 32px;">
                <span class="sub-title">{{ $t('settings.section_performance') }}</span>
                <p class="settings-tab-description">
                  {{ $t('settings.section_performance_description') }}
                </p>
                <div class="line-style mt-20" />

                <!-- Enable Performance Boosts Toggle -->
                <div>
                  <div class="header-text mt-32">{{ $t('settings.enable_performance_boosts') }}</div>
                  <span class="description-text">{{ $t('settings.enable_performance_boosts_description') }}</span>
                </div>

                <div v-if="settingData.performance_review" class="flex-center mt-18">
                  <div class="switch mr-16">
                    <div class="can-toggle">
                      <input class="input" type="checkbox" id="performance_boosts_enabled"
                        v-model="settingData.performance_review.enabled" />
                      <label for="performance_boosts_enabled" :class="`${settingData.performance_review.enabled
                        ? 'power-on'
                        : 'power-off'
                        }`">
                        <div class="switch-body flex-mid">
                          <div v-if="settingData.performance_review.enabled" class="mr-auto ml-14 mt-2">
                            ON
                          </div>
                          <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <span class="fc-4A4A4A fs-14 fw-700">{{ $t('settings.performance_boosts') }}</span>
                </div>

                <div v-if="settingData.performance_review" class="description-text mt-8" style="font-style: italic; color: #908D95;">
                  {{ settingData.performance_review.enabled ?
                    'Managers can award gems during performance reviews. These awards contribute to Impact Ratings.' :
                    'Performance Boosts are disabled. Team members will not receive gems from managers, and Impact Ratings will not include performance review data.' }}
                </div>

                <div v-if="settingData.performance_review && settingData.performance_review.enabled">
                  <!-- <div class="line-style mt-32" /> -->
                  <div>
                    <div class="header-text mt-32">{{ $t('settings.performance_boost_notice') }}</div>
                    <span class="description-text">{{ $t('settings.performance_boost_notice_description') }}</span>
                  </div>
                </div>
                <div v-if="settingData.performance_review && settingData.performance_review.enabled" id="formReport" class="mx-2 mt-32 grid-2-50">
                  <div>
                    <el-form-item style="margin-bottom: 16px">
                        <span slot="label" class="inputLabelStyle">{{ $t('settings.pending_after') }}</span>
                        <el-select v-model="settingData.performance_review.pending" class="inputReportStyle" placeholder="Select duration" @change="pendingAfterChange">
                          <el-option v-for="month in [1, 2, 3]" :key="month" :label="`${month} ${month === 1 ? 'month' : 'months'}`" :value="month"></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item style="margin-bottom: 16px">
                        <span slot="label" class="inputLabelStyle">{{ $t('settings.overdue_after') }}</span>
                        <el-select v-model="settingData.performance_review.overdue" class="inputReportStyle" placeholder="Select duration">
                          <el-option v-for="month in overdueMonths" :key="month" :label="`${month} ${month === 1 ? 'month' : 'months'}`" :value="month"></el-option>
                        </el-select>
                      </el-form-item>
                  </div>
                </div>

                <div v-if="settingData.performance_review && settingData.performance_review.enabled" class="flex-center mt-18">
                  <div class="switch mr-16">
                    <div class="can-toggle">
                      <input class="input" type="checkbox" id="ai_review_feedback"
                        v-model="settingData.performance_review.ai_review_feedback" />
                      <label for="ai_review_feedback" :class="`${settingData.performance_review.ai_review_feedback
                        ? 'power-on'
                        : 'power-off'
                        }`">
                        <div class="switch-body flex-mid">
                          <div v-if="settingData.performance_review.ai_review_feedback" class="mr-auto ml-14 mt-2">
                            ON
                          </div>
                          <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <span class="fc-4A4A4A fs-14 fw-700">{{ $t('settings.ai_reviewed_feedback') }}</span>
                </div>

                <div v-if="settingData.performance_review && settingData.performance_review.enabled" class="flex-center mt-18" :style="settingData.performance_review.pending != 1?'opacity: 0.5':''">
                  <div class="switch mr-16">
                    <div class="can-toggle">
                      <input class="input" type="checkbox" id="reset_completed_monthly"
                        v-model="settingData.performance_review.reset_completed_monthly"
                        :disabled="settingData.performance_review.pending != 1"
                        />
                      <label for="reset_completed_monthly" :class="`${settingData.performance_review.reset_completed_monthly
                        ? 'power-on'
                        : 'power-off'
                        }`">
                        <div class="switch-body flex-mid">
                          <div v-if="settingData.performance_review.reset_completed_monthly" class="mr-auto ml-14 mt-2">
                            ON
                          </div>
                          <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <span class="fc-4A4A4A fs-14 fw-700">{{ $t('settings.reset_monthly') }}</span>
                </div>

                <div class="line-style mt-32" />
                <div class="header-text mt-32">{{ $t('settings.performance_conversations') }}</div>
                <div class="description-text">
                  {{ $t('settings.performance_conversations_description') }}
                </div>
                <div v-if="settingData.performance_conversations" class="flex-center mt-24">
                  <div class="switch mr-16">
                    <div class="can-toggle">
                      <input class="input" type="checkbox" id="performance_conversations_enabled"
                        v-model="settingData.performance_conversations.enabled" />
                      <label for="performance_conversations_enabled" :class="`${settingData.performance_conversations.enabled
                        ? 'power-on'
                        : 'power-off'
                        }`">
                        <div class="switch-body flex-mid">
                          <div v-if="settingData.performance_conversations.enabled" class="mr-auto ml-14 mt-2">
                            ON
                          </div>
                          <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <span class="fc-4A4A4A fs-14 fw-700">{{ $t('settings.performance_conversations') }}</span>
                </div>

              </div>
            </el-form>
          </el-tab-pane>

          <el-tab-pane name="values">
            <span slot="label" class="title-bar">{{ $t('settings.tab_values') }}</span>
            <!-- Skills & Values Tab -->
            <el-form class="margin-subpages" @submit.native.prevent>
              <div style="margin-top: 32px;"></div>
              <span class="sub-title">{{ $t('settings.section_values') }}</span>
              <p class="settings-tab-description">
                {{ $t('settings.section_values_description') }}
              </p>
              <div class="line-style mt-20" />
              
              <div class="flex">
                <div>
                  <div ref="recognition-values" class="header-text mt-24">
                    {{ $t('settings.recognition_values') }}
                  </div>
                  <div class="description-text">
                    {{ $t('settings.recognition_values_description') }}
                  </div>
                </div>
                <el-popover placement="bottom-end" width="200" trigger="click" class="mt-24 ml-auto"
                  v-model="popover.visibleRecognition" v-if="settingData.recognitionValue_checked && multiLang"
                  popper-class="language-selector-popover">
                  <div class="language-selector-content">
                    <div class="language-selector-header">
                      <i class="el-icon-s-flag"></i>
                      <span>Select Language</span>
                    </div>
                    <div v-for="val in language" :key="val.code" 
                         class="language-option" 
                         :class="{ 'active': popover.langRecognition === val.code.toUpperCase() }"
                         @click="setLanguage('recognition', val.code.toUpperCase())">
                      <div class="language-flag">
                        <div class="flag-icon" :class="`flag-${val.code.toLowerCase()}`">
                          {{ getLanguageEmoji(val.code) }}
                        </div>
                      </div>
                      <span class="language-text">{{ val.text }}</span>
                      <i v-if="popover.langRecognition === val.code.toUpperCase()" class="el-icon-check language-check"></i>
                    </div>
                  </div>
                  <div slot="reference" class="language-selector-button">
                    <div class="language-selector-content-btn">
                      <div class="language-flag-btn">
                        <div class="flag-icon-btn" :class="`flag-${getCurrentLanguageCode('recognition').toLowerCase()}`">
                          {{ getLanguageEmoji(getCurrentLanguageCode('recognition')) }}
                        </div>
                      </div>
                      <span class="language-text-btn">{{ popover.langRecognition }}</span>
                      <i class="el-icon-arrow-down language-arrow" :class="{ 'rotated': popover.visibleRecognition }"></i>
                    </div>
                  </div>
                </el-popover>
              </div>
              <div class="flex-center mt-18">
                <div class="switch mr-16">
                  <div class="can-toggle">
                    <input class="input" type="checkbox" id="recognitionValue_checked"
                      v-model="settingData.recognitionValue_checked" />
                    <label for="recognitionValue_checked" :class="`${settingData.recognitionValue_checked
                      ? 'power-on'
                      : 'power-off'
                      }`">
                      <div class="switch-body flex-mid">
                        <div v-if="settingData.recognitionValue_checked" class="mr-auto ml-14 mt-2">
                          ON
                        </div>
                        <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                      </div>
                    </label>
                  </div>
                </div>
                <span class="fc-4A4A4A fs-14 fw-700">{{ $t('settings.recognition_values') }}</span>
              </div>
              <div :class="`setting-row ${settingData.recognitionValue_checked
                ? 'mt-24'
                : 'expand-setting'
                }`" style="margin-left: 7px;">
                <div ref="recognitionValue_checked_row">
                  <div v-if="popover.langRecognition == 'EN'">
                    <draggable v-model="recognitionDataSetting" v-bind="dragOptions" @update="updateCradList"
                      class="flex-center flex-wrap" style="gap: 12px 0">
                      <div v-for="(value) in recognitionValue" :key="value.value + '_chip'" class="relative">
                        <div class="recognition-chip cursor-pointer"
                             :style="$utils('fontStyle', value.label)"
                             @click="openRecognitionEdit(value)"
                             title="Click to edit, describe, or delete">
                          {{ value.label }}
                        </div>
                      </div>
                    </draggable>
                    <div class="mt-12 flex-center" style="flex-wrap: wrap; gap: 12px 0">
                      <span @click="openRecognitionCreate"
                        class="recognition-tags flex-center cursor-pointer">
                        <span class="mr-12 fs-16"><i class="el-icon-plus" style="font-weight: 700"></i></span>
                        <span class="">{{ $t('settings.new_value') }}</span>
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    <draggable v-model="recognitionDataSetting" v-bind="dragOptions" @update="updateCradList"
                      class="flex-center flex-wrap" style="gap: 12px 0">
                      <div v-for="(value) in recognitionValue" :key="value.value + '_chip'" class="relative">
                        <div class="recognition-chip cursor-pointer"
                             :class="{ 'recognition-chip--untranslated': isCurrentLangUntranslated(value) }"
                             :style="$utils('fontStyle', displayNameFor(value))"
                             @click="openRecognitionEdit(value)"
                             :title="isCurrentLangUntranslated(value)
                               ? 'Not yet translated — click to add ' + currentLanguageName + ' translation'
                               : 'Click to edit, describe, or delete'">
                          {{ displayNameFor(value) }}
                        </div>
                        <div class="popup">
                          <div class="fs-10 fw-700">DEFAULT</div>
                          <div class="fs-12 opa-07">{{ value.label }}</div>
                        </div>
                      </div>
                    </draggable>
                    <div class="mt-12 flex-center">
                      <span class="
                          recognition-tags
                          flex-center
                          disable
                          cursor-default
                        ">
                        <span class="mr-12 fs-16"><i class="el-icon-plus" style="font-weight: 700"></i></span>
                        <span class="">{{ $t('settings.new_value') }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="line-style mt-24" />
              <div class="flex">
                <div>
                  <div ref="peer-feedbak" class="header-text mt-24">
                    {{ $t('settings.peer_feedback') }}
                  </div>
                  <div class="description-text">
                    {{ $t('settings.peer_feedback_description') }}
                  </div>
                </div>
                <el-popover placement="bottom-end" width="200" trigger="click" class="mt-24 ml-auto"
                  v-model="popover.visiblePeerFeedback" v-if="settingData.peerFeedbackInteractions_checked && multiLang"
                  popper-class="language-selector-popover">
                  <div class="language-selector-content">
                    <div class="language-selector-header">
                      <i class="el-icon-s-flag"></i>
                      <span>Select Language</span>
                    </div>
                    <div v-for="val in language" :key="val.code" 
                         class="language-option" 
                         :class="{ 'active': popover.langPeerFeedback === val.code.toUpperCase() }"
                         @click="setLanguage('peerFeedback', val.code.toUpperCase())">
                      <div class="language-flag">
                        <div class="flag-icon" :class="`flag-${val.code.toLowerCase()}`">
                          {{ getLanguageEmoji(val.code) }}
                        </div>
                      </div>
                      <span class="language-text">{{ val.text }}</span>
                      <i v-if="popover.langPeerFeedback === val.code.toUpperCase()" class="el-icon-check language-check"></i>
                    </div>
                  </div>
                  <div slot="reference" class="language-selector-button">
                    <div class="language-selector-content-btn">
                      <div class="language-flag-btn">
                        <div class="flag-icon-btn" :class="`flag-${getCurrentLanguageCode('peerFeedback').toLowerCase()}`">
                          {{ getLanguageEmoji(getCurrentLanguageCode('peerFeedback')) }}
                        </div>
                      </div>
                                            <span class="language-text-btn">{{ popover.langPeerFeedback }}</span>
                      <i class="el-icon-arrow-down language-arrow" :class="{ 'rotated': popover.visiblePeerFeedback }"></i>
                    </div>
                  </div>
                </el-popover>
              </div>
              <div class="flex-center mt-24">
                <div class="switch mr-16">
                  <div class="can-toggle">
                    <input class="input" type="checkbox" id="peerFeedbackInteractions_checked"
                      v-model="settingData.peerFeedbackInteractions_checked" />
                    <label for="peerFeedbackInteractions_checked" :class="`${settingData.peerFeedbackInteractions_checked
                      ? 'power-on'
                      : 'power-off'
                      }`">
                      <div class="switch-body flex-mid">
                        <div v-if="settingData.peerFeedbackInteractions_checked" class="mr-auto ml-14 mt-2">
                          ON
                        </div>
                        <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                      </div>
                    </label>
                  </div>
                </div>
                <span class="fc-4A4A4A fs-14 fw-700">{{ $t('settings.peer_feedback_interactions') }}</span>
              </div>
              <div :class="`setting-row ${settingData.peerFeedbackInteractions_checked
                ? 'mt-24'
                : 'expand-setting'
                }`" style="margin-left: 7px;">
                <div ref="peerFeedbackInteractions_checked_row">
                  <div v-if="popover.langPeerFeedback == 'EN'">
                    <div class="flex-center flex-wrap" style="gap: 12px 0">
                      <span v-for="values in peerFeedbackExcels" :key="values.key"
                            class="peer-feedback-tags peer-feedback-chip flex-center cursor-pointer"
                            @click="inspectPeerFeedbackTag(values)"
                            title="Click to edit or delete">
                        {{ skillDisplayNameFor(values) }}
                      </span>
                    </div>
                    <div class="mt-12 flex-center" style="flex-wrap: wrap; gap: 12px 0">
                      <span @click="openPeerFeedbackCreate"
                        class="peer-feedback-tags flex-center cursor-pointer">
                        <span class="mr-12 fs-16"><i class="el-icon-plus" style="font-weight: 700"></i></span>
                        <span class="">{{ $t('settings.new_skill') }}</span>
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    <div class="flex-center flex-wrap" style="gap: 12px 0">
                      <span v-for="value in peerFeedbackExcels" :key="value.key + '_chip'"
                            class="peer-feedback-tags peer-feedback-chip flex-center cursor-pointer"
                            :class="{ 'peer-feedback-chip--untranslated': isPeerFeedbackUntranslated(value) }"
                            @click="inspectPeerFeedbackTag(value)"
                            :title="isPeerFeedbackUntranslated(value)
                              ? 'Not yet translated — click to add ' + currentPeerFeedbackLanguageName + ' translation'
                              : 'Click to edit or delete'">
                        {{ skillDisplayNameFor(value) }}
                      </span>
                    </div>
                    <div class="mt-12 flex-center">
                      <span class="
                          peer-feedback-tags
                          flex-center
                          disable
                          cursor-default
                        ">
                        <span class="mr-12 fs-16"><i class="el-icon-plus" style="font-weight: 700"></i></span>
                        <span class="">New Excel Tag</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </el-form>
          </el-tab-pane>

          <el-tab-pane name="village">
            <span slot="label" class="title-bar">{{ $t('settings.tab_village') }}</span>
            <!-- Happily Village Tab -->
            <el-form class="margin-subpages" @submit.native.prevent>
              <div style="margin-top: 32px;">
                <span class="sub-title">{{ $t('settings.section_village') }}</span>
                <p class="settings-tab-description">
                  {{ $t('settings.section_village_description') }}
                </p>
                <div class="line-style mt-20" />

                <div class="header-text mt-32">{{ $t('settings.village_access') }}</div>
                <div class="description-text">
                  {{ $t('settings.village_access_description') }}
                </div>
                <div class="flex-center mt-24">
                  <div class="switch mr-16">
                    <div class="can-toggle">
                      <input class="input" type="checkbox" id="happilyVillageAccess_checked"
                        v-model="settingData.happilyVillageAccess_checked" />
                      <label for="happilyVillageAccess_checked" :class="`${settingData.happilyVillageAccess_checked
                        ? 'power-on'
                        : 'power-off'
                        }`">
                        <div class="switch-body flex-mid">
                          <div v-if="settingData.happilyVillageAccess_checked" class="mr-auto ml-14 mt-2">
                            ON
                          </div>
                          <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <span class="fc-4A4A4A fs-14 fw-700">{{ $t('settings.happily_village_access') }}</span>
                </div>

                <div class="line-style mt-32" />
                <SettingsToggleRow
                  id="fairPlayBoostEnabled"
                  :title="$t('settings.fair_play_boost')"
                  :description="$t('settings.fair_play_boost_description')"
                  v-model="settingData.battle_stadium_scoring.fair_play_boost_enabled"
                />
                <div class="description-text mt-8 fair-play-effective-note">
                  <i class="el-icon-time" aria-hidden="true"></i>
                  {{ settingData.battle_stadium_scoring.fair_play_boost_enabled
                    ? $t('settings.fair_play_boost_enabled_note')
                    : $t('settings.fair_play_boost_disabled_note') }}
                </div>

                <div class="line-style mt-32" />
                <div class="header-text mt-32">{{ $t('settings.topic_creation_permissions') }}</div>
                <div class="description-text">
                  {{ $t('settings.topic_creation_permissions_description') }}
                </div>
                <div class="flex-center mt-24">
                  <div class="switch mr-16">
                    <div class="can-toggle">
                      <input class="input" type="checkbox" id="create_topics"
                        v-model="settingData.create_topics" />
                      <label for="create_topics" :class="`${settingData.create_topics
                        ? 'power-on'
                        : 'power-off'
                        }`">
                        <div class="switch-body flex-mid">
                          <div v-if="settingData.create_topics" class="mr-auto ml-14 mt-2">
                            ON
                          </div>
                          <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <span class="fc-4A4A4A fs-14 fw-700">{{ $t('settings.allow_employee_topic_creation') }}</span>
                </div>
                <div class="description-text mt-8" style="font-style: italic; color: #908D95;">
                  {{ settingData.create_topics ? 
                    'All employees can create new topics and start discussions.' : 
                    'Only company admins can create new topics. All employees can participate in discussions.' }}
                </div>

                <div class="line-style mt-32" />
                <div class="header-text mt-32">{{ $t('settings.town_hall_agent') }}</div>
                <div class="description-text">
                  {{ $t('settings.town_hall_agent_description') }}
                </div>
                <div class="flex-center mt-24">
                  <div class="switch mr-16">
                    <div class="can-toggle">
                      <input class="input" type="checkbox" id="townHallAgent_checked"
                        v-model="settingData.townHallAgent_checked" />
                      <label for="townHallAgent_checked" :class="`${settingData.townHallAgent_checked
                        ? 'power-on'
                        : 'power-off'
                        }`">
                        <div class="switch-body flex-mid">
                          <div v-if="settingData.townHallAgent_checked" class="mr-auto ml-14 mt-2">
                            ON
                          </div>
                          <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <span class="fc-4A4A4A fs-14 fw-700">{{ $t('settings.town_hall_agent') }}</span>
                </div>

                <div :class="`setting-row ${settingData.townHallAgent_checked ? 'mt-24' : 'expand-setting'}`">
                  <div class="description-text mt-16" style="font-style: italic;">
                    Add conversation themes below to guide the Town Hall Agent in creating relevant and engaging topics for your team.
                  </div>
                  <div class="flex-center flex-wrap mt-16" style="gap: 12px 0">
                    <span v-for="theme in townHallThemes" :key="theme.key" class="peer-feedback-tags flex-center">
                      <span>{{ theme.name }}</span>
                      <span class="ml-12 fs-16 cursor-pointer" @click="removeTownHallTheme(theme.key)">
                        <i class="el-icon-close" style="font-weight: 700"></i>
                      </span>
                    </span>
                  </div>
                  <div class="mt-12 flex-center" style="flex-wrap: wrap; gap: 12px 0">
                    <span @click="showTownHallThemeInput" v-if="!saveTownHallThemeInput"
                      class="peer-feedback-tags flex-center cursor-pointer">
                      <span class="mr-12 fs-16"><i class="el-icon-plus" style="font-weight: 700"></i></span>
                      <span class="">{{ $t('settings.add_theme') }}</span>
                    </span>
                    <input class="peer-feedback-tags input" v-if="saveTownHallThemeInput" style="height: 18px"
                      v-model="saveTownHallThemeValue" ref="saveTownHallThemeInput"
                      @keyup.enter="handleInputTownHallThemeConfirm" @blur="handleInputTownHallThemeConfirm" 
                      placeholder="e.g., Innovation, Work-Life Balance" />
                  </div>
                </div>
              </div>
            </el-form>
          </el-tab-pane>

          <el-tab-pane name="emailNotifications">
            <span slot="label" class="title-bar">{{ $t('settings.tab_email_notifications') }}</span>
            <!-- Email Notifications Tab -->
            <el-form class="margin-subpages">
              <div id="emailNotifications" v-if="settingData && settingData.emailNotifications">
                <span class="sub-title">{{ $t('settings.section_email_notifications') }}</span>
                <p class="settings-tab-description">
                  {{ $t('settings.section_email_notifications_description') }}
                </p>
                <div class="line-style mt-20" />

                <div class="settings-group-heading mt-24">Activity alerts</div>
                <div class="description-text">
                  Send managers an email when an important team activity happens.
                </div>

                <!-- Event-triggered notifications -->
                <SettingsToggleRow
                  id="managerRewardRedemption_checked"
                  title="Reward Redemptions"
                  description="Managers get an email when one of their team members redeems a reward."
                  v-model="settingData.emailNotifications.managerRewardRedemption"
                />

                <SettingsToggleRow
                  id="managerPeerFeedbackOutstanding_checked"
                  title="Outstanding Peer Feedback"
                  description="Managers get an email when a direct report receives a Truly Outstanding rating on peer feedback."
                  v-model="settingData.emailNotifications.managerPeerFeedbackOutstanding"
                />

                <div class="line-style mt-32" />

                <div class="settings-group-heading mt-24">Scheduled reports</div>
                <div class="description-text">
                  Choose the recurring summaries sent to managers and HR.
                </div>

                <!-- Scheduled reports -->
                <SettingsToggleRow
                  id="managerActivityReport_checked"
                  title="Manager Activity Report"
                  description="Managers get a monthly email summarizing their management activity and performance."
                  v-model="settingData.report_activity_manager"
                />

                <SettingsToggleRow
                  id="hrMonthlyReports_checked"
                  title="HR Monthly Overview"
                  description="The HR team gets a monthly email with key insights and metrics across the organization."
                  v-model="settingData.report_monthlyhr"
                />

                <div class="line-style mt-32" />

                <!-- Daily Insight Report content settings -->
                <div class="mt-24">
                  <div class="header-text">Daily Insight Report: Feedback Visibility</div>
                  <div class="description-text">
                    Choose how many levels of open-ended feedback each manager sees in their Daily Insight Report.
                  </div>
                  <div class="mt-18">
                    <el-select
                      v-model="settingData.feedback_rollup_scope"
                      class="inputReportStyle"
                      style="width: 360px;"
                      placeholder="Select visibility scope"
                    >
                      <el-option
                        v-for="option in feedbackRollupScopeOptions"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value"
                      ></el-option>
                    </el-select>
                    <div
                      v-if="feedbackRollupScopeDescription"
                      class="fc-4A4A4A fs-14 mt-8 opa-07"
                      style="max-width: 580px;"
                    >
                      {{ feedbackRollupScopeDescription }}
                    </div>
                  </div>
                </div>

              </div>
            </el-form>
          </el-tab-pane>

        </el-tabs>
      </div>
    </div>

    <!-- Modal Holiday Presets -->
    <el-dialog :visible.sync="showModal_holiday_presets" :before-close="closeModalHolidayPresets" width="1100px"  top="8vh" custom-class="holiday-preset-dialog">
            <div class="flex-center" style="background-color:#F8F8F8;">
              <div class="modal-1" style="width:640px; "> 
                <div  class="flex-column" style="margin-top: 40px;">
                    <div class="flex-center" style="justify-content: space-between;">
                    <div class="flex-column">
                      <span class="fs-20 fw-700 mb-8" style="color: #000;">
                        Holiday Presets
                      </span>
                      <div class="opa-06">
                        Manage when daily pulse questions should not be delivered
                      </div>

                    </div>
                
                    <el-button style="width:133.7px;height:33px;background: #32C2D5;color: #FFFFFF;border: none;font-size: 14px;margin-right: 32px;padding: 0px;" @click="createPreset">
                      <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                        <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                          <path d="M11 13H5v-2h6V5h2v6h6v2h-6v6h-2v-6Z"/>
                        </svg>
                        <span>Create Preset</span>
                      </div>
                    </el-button>

                    </div>
                    <div class="fs-16 fw-700 pt-32 fc-323232" style="margin-top: 20px;">My Presets Library</div>
                    <div>
                    <el-input class="input-style mb-32 mt-12 " style="font-size: 15px; width: 260px !important" autosize
                      :placeholder="$t('global.Search')"  v-model="inputSearch_preset" clearable></el-input>
                    </div>
                    <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loading_preset">
                      <loading-even></loading-even>
                    </div>

                    <div v-else>
                      <!-- card -->
                      <div v-for="(item,index) in presetlist" :key="index" class="mb-8 cursor-pointer" :class="`${item.focus_preset?'preset-focus':'preset-library'}`" @click="ClickEditPresets(index)">
                        <div class="flex-center" style="justify-content: left;">
                      
                          <div class="flex-center" style="width: 396px;">
                            <div class="flex-center" :style="`justify-content: center;background:${item.focus_preset?'#EEE5FD':'#EDEDED'} 0% 0% no-repeat padding-box;border-radius: 12px;width: 52px;height: 52px;color:${item.focus_preset?'#6C30CC':'#000'}`">{{ item.total_assignments }}</div>
                            <div class="flex-column" style="margin-left: 16px;">
                              <span class="fs-15 fw-700 fc-2E2E2E" >{{ item.name }}</span>
                              <span class="fs-13 fc-2E2E2E mt-4" >{{getAssignmentSummary(item)}}</span>
                            </div>
                          </div>
                          <div class="flex-center" style="justify-content: space-between;width:205px;">
                            
                            <div class="fs-12 fc-2E2E2E" >{{ item.total_assignments }} assignments total</div>
                            <div class="arrow-right">
                              <svg xmlns="http://www.w3.org/2000/svg" width="10.477" height="20" viewBox="0 0 10.477 20">
                                <path id="Path_40066" data-name="Path 40066" d="M102.335,54.335l-9.524,9.524a.476.476,0,1,1-.674-.674L101.324,54l-9.187-9.187a.476.476,0,0,1,.674-.674l9.524,9.524a.476.476,0,0,1,0,.674" transform="translate(-91.998 -43.998)"/>
                              </svg>
                            </div>

                          </div>


                        </div>
                        


                      </div>

                    </div>




                  </div>
        
                    




              
                </div>

                <div class="modal-2 preset-form-panel" style="width:460px;">

                  <div v-if="status_show_preset_forms" class="flex-center preset-form-empty" style="justify-content: center;text-align: center;">
                    <div class="fs-16 fw-700" style="color: #000;opacity: 0.4;">Create a Holiday Preset to disable daily pulse questions on a person's day off</div>
                  </div>
                  <div v-else class="preset-form-content pb-24">
                    
                  
                    <div class="flex-column" style="margin-top: 40px;">
                      <div class="fs-20 fw-700" style="color: #000;">{{ title_preset }}</div>
                      <div class="fs-14 fw-700 pt-24">Preset Name</div>
                      <div v-if="presetForm_verify.name==true" class="validate-worming-data">
                        <el-input class="input-style mt-8"  style="font-size: 15px; width: 376px !important;" autosize
                        placeholder="Enter preset name"  v-model="presetForm.name"></el-input>
                        <div class="validate-worming-data-text ">
                          Please enter a preset name
                        </div>
                      </div>
                      <div v-else>
                        <el-input class="input-style mt-8" style="font-size: 15px; width: 376px !important;" autosize
                        placeholder="Enter preset name"  v-model="presetForm.name"></el-input>

                      </div>
                      
                    </div>

                    <div class="fs-14 fw-700 pt-16 pb-16">Day Off in the Week</div>

                      <el-checkbox-group
                        v-model="presetForm.dayoff"
                        @change="handleCheckedDayChange"
                      >
                        <el-checkbox v-for="day in dayofweek" :key="day" :label="day" :value="day" class='flex-column fs-13 fw-700 mb-15' style="width: 100%;">
                          {{ day }}
                        </el-checkbox>
                      </el-checkbox-group>

                      <div class="flex-center pt-8">
                        <div class="switch mr-16">
                          <div class="can-toggle">
                            <input class="input" type="checkbox" id="company_holiday"
                              v-model="presetForm.company_holiday" />
                            <label for="company_holiday" :class="`${presetForm.company_holiday
                              ? 'power-on'
                              : 'power-off'
                              }`">
                              <div class="switch-body flex-mid">
                                <div v-if="presetForm.company_holiday" class="mr-auto ml-14 mt-2 fs-13">
                                  ON
                                </div>
                                <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                                
                              </div>
                         
                            </label>
                          </div>
                        </div>
                        <span class="fc-4A4A4A fs-14">Also Apply Company Holidays</span>
                      </div>

                      <!-- Specific Days Off Section -->
                      <div class="fs-14 fw-700 pt-24 pb-8">Specific Days Off</div>
                      <div class="fs-13 fc-908D95 pb-12">Add individual dates when pulse questions should be paused</div>
                      <div v-if="presetForm.holiday_dates && presetForm.holiday_dates.length > 0" style="display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 12px;">
                        <div 
                          class="preset-date-tag" 
                          v-for="(item, index) in presetForm.holiday_dates" 
                          :key="'preset-date-' + index">
                          <i class="el-icon-date date-icon"></i>
                          <span>{{ item }}</span>
                          <i @click="removePresetHolidayDate(index)" class="el-icon-close"></i>
                        </div>
                      </div>
                      <div style="position: relative;">
                        <el-button style="width:160px;height:33px;background: #32C2D5;color: #FFFFFF;border: none;font-size: 14px;padding: 0px;" @click="showPresetDatepicker">
                          <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                            <i class="el-icon-plus" style="font-size: 16px; font-weight: 700;"></i>
                            <span>Add Dates</span>
                          </div>
                        </el-button>
                        <el-date-picker 
                          :clearable="false" 
                          :editable="false" 
                          @change="confirmPresetHolidayDatepicker"
                          class="dialogInputDatepicker" 
                          ref="datepicker_preset_holiday" 
                          type="dates" 
                          v-model="presetForm.holiday_dates_val"
                          placement="bottom-start" 
                          style="position: absolute; top: 0; left: 0; opacity: 0; pointer-events: none;">
                        </el-date-picker>
                      </div>

                      <div class="qd-eyebrow pt-32 pb-2">Audience</div>
                      <div class="fs-12 fc-908D95 mb-8" style="line-height: 1.5;">Applies to anyone matching any of the audiences below.</div>

                      <div class="flex-center preset-section-head" style="justify-content: space-between;">
                        <div class="fs-16 fw-700">Assign to Teams</div>
                        <div class="fs-14 fc-6C30CC pr-16 cursor-pointer" @click="openAddMemberTeam('team')"> + Add Teams</div>
                      </div>
                      <div v-for="team in presetForm.team" :key="team.id+'team'" class="mb-8">
                        <div class="preset-chip">
                          <svg class="preset-chip-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                          <div class="flex-center preset-chip-body">
                            <div class="fs-16 fw-500 fc-323232" style="color: #000;opacity: 1;">{{ team.name }}</div>
                            <div class="fs-13 pl-10 fc-908D95">{{ team.membersteams }} members</div>
                          </div>
                          <div class="pr-16 cursor-pointer" @click="deleteTeam(team.id)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16.707" height="16.707" viewBox="0 0 16.707 16.707">
                              <g id="Close" transform="translate(0.354 0.354)">
                                <path id="Path_2" data-name="Path 2" d="M0,0,16,16" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                                <path id="Path_2_Copy" data-name="Path 2 Copy" d="M-10,0-26,16" transform="translate(26)" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                              </g>
                            </svg>
                          </div>
                        </div>
                      </div>

                      <div class="flex-center preset-section-head" style="justify-content: space-between;">
                        <div class="fs-16 fw-700">Assign to Cohorts</div>
                        <div class="fs-14 fc-6C30CC pr-16 cursor-pointer" @click="openAddMemberTeam('cohort')"> + Add Cohorts</div>
                      </div>
                      <div v-for="cohort in presetForm.cohorts" :key="cohort.id+'cohort'" class="mb-8">
                        <div class="preset-chip">
                          <svg class="preset-chip-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>
                          <div class="flex-center preset-chip-body">
                            <div class="fs-16 fw-500 fc-323232" style="color: #000;opacity: 1;">{{ cohort.name }}</div>
                            <div class="fs-13 pl-10 fc-908D95">{{ cohort.membercount || 0 }} members</div>
                          </div>
                          <div class="pr-16 cursor-pointer" @click="deleteCohort(cohort.id)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16.707" height="16.707" viewBox="0 0 16.707 16.707">
                              <g id="Close" transform="translate(0.354 0.354)">
                                <path id="Path_2" data-name="Path 2" d="M0,0,16,16" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                                <path id="Path_2_Copy" data-name="Path 2 Copy" d="M-10,0-26,16" transform="translate(26)" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                              </g>
                            </svg>
                          </div>
                        </div>
                      </div>

                      <div class="flex-center preset-section-head" style="justify-content: space-between;">
                        <div class="fs-16 fw-700">Assign to Countries</div>
                        <div class="fs-14 fc-6C30CC pr-16 cursor-pointer" @click="openAddMemberTeam('country')"> + Add Countries</div>
                      </div>
                      <div v-for="country in presetForm.countries" :key="country.code+'country'" class="mb-8">
                        <div class="preset-chip">
                          <svg class="preset-chip-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
                          <div class="flex-center preset-chip-body">
                            <div class="fs-16 fw-500 fc-323232" style="color: #000;opacity: 1;">{{ country.name }}</div>
                            <div class="fs-13 pl-10 fc-908D95">{{ country.membercount || 0 }} members</div>
                          </div>
                          <div class="pr-16 cursor-pointer" @click="deleteCountry(country.code)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16.707" height="16.707" viewBox="0 0 16.707 16.707">
                              <g id="Close" transform="translate(0.354 0.354)">
                                <path id="Path_2" data-name="Path 2" d="M0,0,16,16" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                                <path id="Path_2_Copy" data-name="Path 2 Copy" d="M-10,0-26,16" transform="translate(26)" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                              </g>
                            </svg>
                          </div>
                        </div>
                      </div>

                      <div class="qd-eyebrow pt-32 pb-2">Individual overrides</div>
                      <div class="fs-12 fc-908D95 mb-8" style="line-height: 1.5;">These members override the audience above.</div>

                      <div class="flex-center preset-section-head" style="justify-content: space-between;">
                        <div class="fs-16 fw-700">Assign to Members</div>
                        <div class="fs-14 fc-6C30CC pr-16 cursor-pointer" @click="openAddMemberTeam('member')"> + Add Members</div>
                      </div>
                      <div v-for="users in presetForm.users" :key="users.email+'members'" class="mb-8">
                        <div class="preset-chip preset-chip--member">
                          <svg class="preset-chip-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                          <div class="flex-column preset-chip-body">
                            <div class="fs-16 fw-500 fc-323232" style="color: #000;opacity: 1;">{{ users.firstname }} {{ users.lastname }}</div>
                            <div class="fs-13 fw-400 fc-9D9D9D mt-2">{{ users.team_name }}</div>
                          </div>
                          <div class="pr-16 cursor-pointer" @click="deleteUser(users.email)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16.707" height="16.707" viewBox="0 0 16.707 16.707">
                              <g id="Close" transform="translate(0.354 0.354)">
                                <path id="Path_2" data-name="Path 2" d="M0,0,16,16" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                                <path id="Path_2_Copy" data-name="Path 2 Copy" d="M-10,0-26,16" transform="translate(26)" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                              </g>
                            </svg>
                          </div>
                        </div>
                      </div>




                </div>

                  <div v-if="popup_preset.show && !status_show_preset_forms" class="warning-popup-1">
                    <div class="body flex-center" style="width: 368px;justify-content: space-between;">
                      <div class="fs-500 fc-FFFFFF fs-14">
                        {{popup_preset.title}}
                      </div>
                      <div v-if="popup_preset.status=='update'"><el-button style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #FFFFFF;border-radius: 8px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color:#F44336;width:54px;height:32px;font:13px;" @click="deletePreset">{{popup_preset.button_left}}</el-button>
                      <el-button v-if="popup_preset.button_right" style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #32C2D5;border-radius: 8px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color: #32C2D5;width:92px;height:32px;font:13px" @click="savePreset">{{popup_preset.button_right}}</el-button>
                      </div>
                      <div v-else>
                        <el-button style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #FFFFFF;border-radius: 8px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color: #6c30cc;width:62px;height:32px;font:13px;" @click="clearData">{{popup_preset.button_left}}</el-button>
                      <el-button  style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #32C2D5;border-radius: 8px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color: #32C2D5;width:104px;height:32px;font:13px" @click="savePreset">{{popup_preset.button_right}}</el-button>
                      </div>
                    </div>
                  </div>



                
                



                    
              </div>
              

            </div>

    </el-dialog>

     <!-- Add Member and Team -->
     <el-dialog :visible.sync="addMemberTeam" :before-close="cancelselectedTeamandMember"  width="1120px" custom-class="add-member-team-dialog" top="3vh">
        <div class="flex-center" style="background-color:#F8F8F8;">
          <div class="modal-1" style="width:360px;background: #F8F8F8 0% 0% no-repeat padding-box !important; height: 94vh; min-height: 600px; padding-left: 16px !important;">
            <div class="fs-20 fc-2D2E36 fw-700 pt-24 pb-16" style="padding-left: 8px;">{{selectedAssignmentCount}} {{ addMemberTeamForm.title_left }}</div>

            <div v-if="addMemberTeamForm.type=='team'" style="padding-left: 8px; padding-right: 16px; max-height: calc(94vh - 120px); overflow-y: auto;">
              <div v-for="team in selected_team" :key="`${team.id}_select_team`" class="selected-team-item">
              <div class="flex-center" style="justify-content: space-between;">


                <div class="flex-center" style="justify-content: left; flex: 1; min-width: 0;">
                  <img  style="width: 32px;height: 32px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 8px; flex-shrink: 0;">
                  <div style="min-width: 0; flex: 1;">
                    <div class="fs-14 fc-4A4A4A fw-600" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{team.name}}</div>
                    <div class="fs-12 fw-400 fc-9D9D9D">{{team.membersteams}} members</div>
                  </div>
                </div>


                <div class="cursor-pointer" style="padding: 4px;" @click="deleteTeam(team.id)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16.707 16.707">
                    <g id="Close" transform="translate(0.354 0.354)">
                      <path id="Path_2" data-name="Path 2" d="M0,0,16,16" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                      <path id="Path_2_Copy" data-name="Path 2 Copy" d="M-10,0-26,16" transform="translate(26)" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                    </g>
                  </svg>
                </div>

              </div>

              

              </div>
            </div>
            <div v-else-if="addMemberTeamForm.type=='cohort'" style="padding-left: 8px; padding-right: 16px; max-height: calc(94vh - 120px); overflow-y: auto;">
              <div v-for="cohort in selected_cohort" :key="`${cohort.id}_select_cohort`" class="selected-team-item">
              <div class="flex-center" style="justify-content: space-between;">


                <div class="flex-center" style="justify-content: left; flex: 1; min-width: 0;">
                  <div style="width: 32px; height: 32px; border-radius: 50%; background: #F5EFFF; margin-right: 8px; flex-shrink: 0; display: flex; align-items: center; justify-content: center;">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6C30CC" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>
                  </div>
                  <div style="min-width: 0; flex: 1;">
                    <div class="fs-14 fc-4A4A4A fw-600" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{cohort.name}}</div>
                    <div class="fs-12 fw-400 fc-9D9D9D">{{cohort.membercount || 0}} members</div>
                  </div>
                </div>


                <div class="cursor-pointer" style="padding: 4px;" @click="deleteCohort(cohort.id)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16.707 16.707">
                    <g id="Close" transform="translate(0.354 0.354)">
                      <path id="Path_2" data-name="Path 2" d="M0,0,16,16" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                      <path id="Path_2_Copy" data-name="Path 2 Copy" d="M-10,0-26,16" transform="translate(26)" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                    </g>
                  </svg>
                </div>

              </div>

              </div>
            </div>
            <div v-else-if="addMemberTeamForm.type=='country'" style="padding-left: 8px; padding-right: 16px; max-height: calc(94vh - 120px); overflow-y: auto;">
              <div v-for="country in selected_country" :key="`${country.code}_select_country`" class="selected-team-item">
              <div class="flex-center" style="justify-content: space-between;">


                <div class="flex-center" style="justify-content: left; flex: 1; min-width: 0;">
                  <div style="width: 32px; height: 32px; border-radius: 50%; background: #F5EFFF; margin-right: 8px; flex-shrink: 0; display: flex; align-items: center; justify-content: center;">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6C30CC" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
                  </div>
                  <div style="min-width: 0; flex: 1;">
                    <div class="fs-14 fc-4A4A4A fw-600" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{country.name}}</div>
                    <div class="fs-12 fw-400 fc-9D9D9D">{{country.membercount || 0}} members</div>
                  </div>
                </div>


                <div class="cursor-pointer" style="padding: 4px;" @click="deleteCountry(country.code)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16.707 16.707">
                    <g id="Close" transform="translate(0.354 0.354)">
                      <path id="Path_2" data-name="Path 2" d="M0,0,16,16" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                      <path id="Path_2_Copy" data-name="Path 2 Copy" d="M-10,0-26,16" transform="translate(26)" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                    </g>
                  </svg>
                </div>

              </div>

              </div>
            </div>
            <div v-else style="padding-left: 8px; padding-right: 16px; max-height: calc(94vh - 120px); overflow-y: auto;">
              <div v-for="user in selected_user" :key="`${user.email}`" class="selected-team-item">
              <div class="flex-center" style="justify-content: space-between;">


                <div class="flex-center" style="justify-content: left; flex: 1; min-width: 0;">
                  <img v-if="user.profilepic_crop" :src="user.profilepic_crop" style="width: 32px;height: 32px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 8px; flex-shrink: 0;" @error="$event.target.style.display='none'">
                  <div v-else style="width: 32px;height: 32px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 8px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; color: #666; font-size: 12px; font-weight: 600;">
                    {{ getInitials(user.firstname, user.lastname) }}
                  </div>
                  <div style="min-width: 0; flex: 1;">
                    <div class="fs-14 fc-4A4A4A fw-600" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{user.firstname}} {{user.lastname}}</div>
                    <div class="fs-12 fc-908D95 fw-400" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{user.team_name}}</div>
                  </div>
                </div>


                <div class="cursor-pointer" style="padding: 4px;" @click="deleteUser(user.email)">
                  <img :src="$utils('icons', 'x-16x16px')" style="width: 14px;height: 14px;">
                </div>

              </div>

              

              </div>


            </div>
          </div>

          <div class="modal-2" style="width:760px;background: #FFFFFF 0% 0% no-repeat padding-box !important;overflow-y: hidden !important;overflow-x: hidden !important; height: 94vh; min-height: 600px;">
            
            <div class="flex-column" style="justify-content: space-between; padding: 24px 24px 24px 20px;">
              <div class="fs-24 fw-700" style="color: #2D2E36;">{{addMemberTeamForm.title}}</div>
              <div>
                <el-input v-model="searchmemberandteamandMember" style="width: 300px;" :placeholder="addMemberTeamForm.placeholder" class="w-100 mt-16"></el-input>
              </div>
              <div class="fs-14 fc-908D95 mt-12 mb-12">Results based on the search terms…</div>
              <div>

                <div v-if="addMemberTeamForm.type=='team'">


                  <div class="grid-selection-container">
                    <!-- All Teams Selection -->
                    <div class="all-teams-button" @click="toggleAllTeams">
                      <div class="flex-center" style="justify-content: center; width: 100%; height: 100%; align-items: center;">
                        <i :class="allTeamsSelected ? 'el-icon-check' : 'el-icon-plus'" style="font-size: 18px; margin-right: 8px; color: #32C2D5; font-weight: 700;"></i>
                        <div class="fs-16 fw-700" style="color: #32C2D5; margin-right: 8px;">{{ allTeamsSelected ? 'Deselect All Teams' : 'Select All Teams' }}</div>
                        <div class="fs-14" style="color: #666;">({{ addMemberTeamForm.team ? addMemberTeamForm.team.length : 0 }} teams)</div>
                      </div>
                    </div>
                    
                    <div v-for="(team,id) in addMemberTeamForm.team" :key="addMemberTeamForm.team[id].id"  :class="addMemberTeamForm.team[id].statusClick?'border-blue':''" class="selection-cell" @click="selectedTeamAndMember(id,'team')">
                        <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                          <div style="width: 8px;height: 100%;background: #6C30CC 0% 0% no-repeat padding-box;border-radius: 3px 0px 0px 3px;opacity: 1;"></div>
                          <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;padding-left: 16px;">
                            <div class="flex-column" style="min-width: 0; flex: 1;">
                              <div class="fs-14 fc-4A4A4A fw-700" style="line-height: 1.2; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{addMemberTeamForm.team[id].name}}</div>
                              <div class="fs-12 fc-9D9D9D" style="line-height: 1.2;">{{addMemberTeamForm.team[id].users.length}} members</div>
                          </div>
                          </div>


                        </div>


                      
                      
                    
                    </div>
                  </div>
                </div>
                <div v-else-if="addMemberTeamForm.type=='cohort'">
                  <div class="grid-selection-container">
                    <div v-for="(cohort,id) in addMemberTeamForm.cohort" :key="addMemberTeamForm.cohort[id].id"  :class="addMemberTeamForm.cohort[id].statusClick?'border-blue':''" class="selection-cell" @click="selectedTeamAndMember(id,'cohort')">
                        <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                          <div style="width: 8px;height: 100%;background: #6C30CC 0% 0% no-repeat padding-box;border-radius: 3px 0px 0px 3px;opacity: 1;"></div>
                          <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;padding-left: 16px;">
                            <div class="flex-column" style="min-width: 0; flex: 1;">
                              <div class="fs-14 fc-4A4A4A fw-700" style="line-height: 1.2; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{addMemberTeamForm.cohort[id].name}}</div>
                              <div class="fs-12 fc-9D9D9D" style="line-height: 1.2;">{{addMemberTeamForm.cohort[id].membercount || 0}} members</div>
                          </div>
                          </div>


                        </div>

                    </div>
                  </div>
                </div>
                <div v-else-if="addMemberTeamForm.type=='country'">
                  <div class="grid-selection-container">
                    <div v-for="(country,id) in addMemberTeamForm.country" :key="addMemberTeamForm.country[id].code"  :class="addMemberTeamForm.country[id].statusClick?'border-blue':''" class="selection-cell" @click="selectedTeamAndMember(id,'country')">
                        <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                          <div style="width: 8px;height: 100%;background: #6C30CC 0% 0% no-repeat padding-box;border-radius: 3px 0px 0px 3px;opacity: 1;"></div>
                          <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;padding-left: 16px;">
                            <div class="flex-column" style="min-width: 0; flex: 1;">
                              <div class="fs-14 fc-4A4A4A fw-700" style="line-height: 1.2; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{addMemberTeamForm.country[id].name}}</div>
                              <div class="fs-12 fc-9D9D9D" style="line-height: 1.2;">{{addMemberTeamForm.country[id].membercount || 0}} members</div>
                          </div>
                          </div>


                        </div>

                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="grid-selection-container">
                    <div v-for="(user,id) in addMemberTeamForm.user" :key="addMemberTeamForm.user[id].email"  :class="addMemberTeamForm.user[id].statusClick?'border-blue':''" class="selection-cell" @click="selectedTeamAndMember(id,'user')">
                    
                        <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                          <div style="width: 8px;height: 100%;background: #6C30CC 0% 0% no-repeat padding-box;border-radius: 3px 0px 0px 3px;opacity: 1;"></div>
                          <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                            <img v-if="addMemberTeamForm.user[id].profilepic_crop" :src="addMemberTeamForm.user[id].profilepic_crop" style="width: 32px;height: 32px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 10px;margin-left: 10px;" @error="$event.target.style.display='none'">
                            <div v-else style="width: 32px;height: 32px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 10px;margin-left: 10px; display: flex; align-items: center; justify-content: center; color: #666; font-size: 14px; font-weight: 600;">
                              {{ getInitials(addMemberTeamForm.user[id].firstname, addMemberTeamForm.user[id].lastname) }}
                            </div>
                            <div class="flex-column" style="min-width: 0; flex: 1;">
                              <div class="fs-14 fc-4A4A4A fw-700" style="line-height: 1.2; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{addMemberTeamForm.user[id].firstname}} {{addMemberTeamForm.user[id].lastname}}</div>
                              <div class="fs-12 fc-9D9D9D" style="line-height: 1.2; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{addMemberTeamForm.user[id].team_name}}</div>
                          </div>
                          </div>


                        </div>


                      
                      
                    
                    </div>
                  </div>



                </div>

             


              <div class="flex-center" style="justify-content: flex-end; margin-top: 20px;">
                <el-button type="primary" style="width: 122px;height: 40px;background: #D1D1D1 0% 0% no-repeat padding-box;
                  border: none; margin-right: 16px;" @click="cancelselectedTeamandMember">CANCEL</el-button>
                <el-button type="primary"style="width: 120px;height: 40px;background: #32C2D5 0% 0% no-repeat padding-box;
                  border: none;" @click="submitselectedTeamandMember">SUBMIT</el-button>
              </div>
                
              </div>


              
            </div>


    
                
          </div>
          

        </div>

      </el-dialog>

            <!-- Submit member or team -->

      <el-dialog
        :visible.sync="confirm_add_dialog"
        width="650px" center style="max-height: 600px;min-height: 300px;"
        :before-close="handleClose"
      >
      
        <div class="flex-column" style="height: 300px;max-height: 300px;">
          <div class="fs-16 fc-908D95 fw-700" style="margin-top: 50px;margin-left: 30px;">{{ `Some selected ${assignmentTypeLabelPlural} have existing preset assignments` }}</div>
       
            <div v-for='(text,index) in text_confirm' :key="`${index}_text`" style="margin-top: 20px;margin-left: 30px;overflow-y: scroll;max-height: 300px;">
              {{ text }}
            </div>
            <div style="margin-top: 20px;margin-left: 30px;">Proceeding will override their existing preset assignments. Would you like to continue?</div>
         
        </div>
        <template>
          <div class="flex-center" style="justify-content: right;padding-bottom: 30px;padding-right: 30px;">
            <el-button @click="handleClose">{{ $t('settings.cancel') }}</el-button>
            <el-button type="primary" @click="confirm_Add">
              {{ $t('settings.confirm') }}
            </el-button>
          </div>
        </template>
       
      </el-dialog>

      <!-- Peer Feedback Tag Attributes Modal -->
      <el-dialog :visible.sync="peerFeedbackAttributesModal" width="900px" top="8vh" :before-close="closePeerFeedbackAttributesModal">
        <div class="flex-column">
          <div class="flex-center mb-24" style="justify-content: space-between;">
            <div class="fs-20 fw-700" style="color: #2D2E36;">
              <template v-if="isEditingNewTag">Create New Skill</template>
              <template v-else>Inspect Skill: {{ currentPeerFeedbackTag.name }}</template>
            </div>
            
            <!-- Language Selector for Attributes -->
            <div v-if="multiLang" class="attribute-language-selector">
              <el-popover placement="bottom-end" width="200" trigger="click"
                          v-model="attributeLanguagePopoverVisible"
                          popper-class="language-selector-popover">
                <div class="language-selector-content">
                  <div class="language-selector-header">
                    <i class="el-icon-s-flag"></i>
                    <span>Select Language</span>
                  </div>
                  <div v-for="val in language" :key="val.code" 
                       class="language-option" 
                       :class="{ 'active': currentAttributeLanguage === val.code.toUpperCase() }"
                       @click="setAttributeLanguage(val.code.toUpperCase())">
                    <div class="language-flag">
                      <div class="flag-icon" :class="`flag-${val.code.toLowerCase()}`">
                        {{ getLanguageEmoji(val.code) }}
                      </div>
                    </div>
                    <span class="language-text">{{ val.text }}</span>
                    <i v-if="currentAttributeLanguage === val.code.toUpperCase()" class="el-icon-check language-check"></i>
                  </div>
                </div>
                <div slot="reference" class="language-selector-button">
                  <div class="language-selector-content-btn">
                    <div class="language-flag-btn">
                      <div class="flag-icon-btn" :class="`flag-${currentAttributeLanguage.toLowerCase()}`">
                        {{ getLanguageEmoji(currentAttributeLanguage) }}
                      </div>
                    </div>
                    <span class="language-text-btn">{{ currentAttributeLanguage }}</span>
                    <i class="el-icon-arrow-down language-arrow" :class="{ 'rotated': attributeLanguagePopoverVisible }"></i>
                  </div>
                </div>
              </el-popover>
            </div>
          </div>

          <div v-if="isEditingNewTag" class="peer-feedback-name-block mb-24">
            <div class="fs-16 fw-700 mb-8" style="color: #2D2E36;">Skill name</div>
            <el-input v-model="currentPeerFeedbackTag.name"
                      placeholder="e.g. Communication"
                      maxlength="40"
                      show-word-limit />
            <div class="fs-12 fc-908D95 mt-8">
              Name your skill so reviewers know what to rate. You can generate attributes with AI below.
            </div>
          </div>

          <div class="flex-center mb-16" style="justify-content: space-between;">
            <div class="fs-16 fw-700">Attributes ({{ (currentPeerFeedbackTag.attributes || []).length }}/6)</div>
            <div class="flex-center" style="gap: 12px;">
              <div v-if="multiLang && currentAttributeLanguage !== 'EN'" class="fs-12 fc-908D95">
                Viewing {{ currentAttributeLanguage }} translations
              </div>
              
              <el-button 
                v-if="newTag && (currentPeerFeedbackTag.attributes || []).length < 6"
                type="primary" 
                size="mini" 
                :loading="generatingAttributes"
                @click="generateAttributesWithAI"
                class="ai-generate-btn">
                <i class="el-icon-magic-stick mr-4"></i>
                {{ generatingAttributes ? 'Generating...' : 'Generate with AI' }}
              </el-button>
            </div>
          </div>
          
          <div v-if="attributeValidationError" class="mb-16 fs-14" style="color: #F44336;">
            {{ attributeValidationError }}
          </div>

          <div class="attributes-container">
            <div v-for="(attribute, index) in currentPeerFeedbackTag.attributes || []" :key="index" class="attribute-item mb-12">
              <div class="flex-column">
                <div class="flex-center">
                  <div class="attribute-number">{{ index + 1 }}</div>

                  <el-input
                    v-if="isEditingNewTag || !multiLang"
                    :value="getAttributeEditValue(attribute, index)"
                    :placeholder="`Enter attribute name in ${currentAttributeLanguage}`"
                    class="attribute-input"
                    @blur="saveAttributeEdit(index)"
                    @keyup.enter.native="saveAttributeEdit(index)"
                    @input="updateAttributeName(index, $event)"
                  />
                  <div v-else-if="editingAttributeIndex === index" class="attribute-lang-stack">
                    <div v-for="lang in language" :key="lang.code" class="attribute-lang-row">
                      <div class="attribute-lang-tag">
                        <span class="flag-mini">{{ getLanguageEmoji(lang.code) }}</span>
                        <span class="lang-code">{{ lang.code.toUpperCase() }}</span>
                      </div>
                      <el-input
                        size="small"
                        :value="attribute[`text_${lang.code.toLowerCase()}`] || ''"
                        :placeholder="lang.code.toUpperCase() === 'EN'
                          ? 'Enter attribute in English'
                          : `Translate to ${lang.text}`"
                        class="attribute-lang-input"
                        @input="(val) => updateAttributeNameForLang(index, lang.code, val)"
                        @keyup.enter.native="saveAttributeEdit(index)"
                      />
                    </div>
                  </div>
                  <div v-else class="attribute-name">
                    {{ getAttributeDisplayName(attribute) }}
                  </div>
                  <div v-if="!currentPeerFeedbackTag.status_master">
                    <div class="ml-auto flex-center">
                      <span v-if="!isEditingNewTag && editingAttributeIndex !== index"
                            class="ml-8 fs-14 cursor-pointer"
                            style="color: #6C30CC;"
                            @click="editAttribute(index)"
                            title="Edit attribute">
                        <happily-icon name="edit" :size="16" />
                      </span>
                      <span v-if="!isEditingNewTag && multiLang && editingAttributeIndex === index"
                            class="ml-8 fs-14 cursor-pointer"
                            @click="saveAttributeEdit(index)"
                            title="Done">
                        <i class="el-icon-check" style="color: #3AC47D;"></i>
                      </span>
                      <span v-if="isEditingNewTag || editingAttributeIndex === index"
                            class="ml-8 fs-14 cursor-pointer"
                            @click="removeAttribute(index)"
                            title="Remove attribute">
                        <i class="el-icon-close" style="color: #F44336;"></i>
                      </span>
                    </div>
                  </div>
                </div>
                
                <!-- Translation status indicator -->
                <div v-if="multiLang && currentAttributeLanguage === 'EN' && !isEditingNewTag && editingAttributeIndex !== index" 
                     class="translation-status mt-8">
                  <div class="flex-center" style="gap: 8px;">
                    <div v-for="lang in language" :key="lang.code" 
                         class="translation-indicator"
                         :class="{ 'completed': hasTranslation(attribute, lang.code), 'missing': !hasTranslation(attribute, lang.code) }"
                         :title="`${lang.text}: ${hasTranslation(attribute, lang.code) ? 'Translated' : 'Missing translation'}`">
                      <div class="flag-mini">{{ getLanguageEmoji(lang.code) }}</div>
                      <i :class="hasTranslation(attribute, lang.code) ? 'el-icon-check' : 'el-icon-warning'" 
                         class="status-icon"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="(currentPeerFeedbackTag.attributes || []).length < 6 && !currentPeerFeedbackTag.status_master" class="add-attribute-container">
              <div v-if="!showAddAttributeInput" 
                   class="add-attribute-btn cursor-pointer" 
                   @click="showAddAttributeInputField">
                <i class="el-icon-plus mr-8"></i>
                Add Attribute
              </div>
              <div v-else class="flex-center">
                <el-input
                  v-model="newAttributeName"
                  placeholder="Enter attribute name"
                  class="attribute-input"
                  ref="newAttributeInput"
                  @blur="addAttribute"
                  @keyup.enter.native="addAttribute"
                />
                <span class="ml-8 fs-14 cursor-pointer" @click="cancelAddAttribute" title="Cancel">
                  <i class="el-icon-close" style="color: #F44336;"></i>
                </span>
              </div>
            </div>
          </div>

          <div v-if="!isEditingNewTag"
               class="peer-feedback-delete-row flex-center mt-24"
               style="justify-content: space-between;">
            <div class="flex-column">
              <span class="fs-13 fw-600 fc-4A4A4A">
                {{ currentPeerFeedbackTag.status_master ? 'Disable this skill' : 'Delete this skill' }}
              </span>
              <span v-if="currentPeerFeedbackTag.status_master" class="fs-12 fc-908D95 mt-4">
                Hides it from new peer feedback. Past feedback keeps its association.
              </span>
            </div>
            <el-button size="small" type="danger" plain
                       :icon="currentPeerFeedbackTag.status_master ? 'el-icon-remove-outline' : 'el-icon-delete'"
                       @click="confirmDeletePeerFeedbackSkill">
              {{ currentPeerFeedbackTag.status_master ? 'Disable skill' : 'Delete skill' }}
            </el-button>
          </div>

          <div class="flex-center mt-32" style="justify-content: right;">
            <el-button @click="closePeerFeedbackAttributesModal">Cancel</el-button>
            <template v-if="!currentPeerFeedbackTag.status_master">
              <el-button v-if="isEditingNewTag" type="primary" @click="saveNewPeerFeedbackTag" :disabled="!canSaveNewTag">
                Create Skill Tag
              </el-button>
              <el-button v-else type="primary" @click="savePeerFeedbackTagChanges">
                Save Changes
              </el-button>
            </template>
          </div>
        </div>
      </el-dialog>

      <el-dialog
        :visible.sync="recognitionEditModal"
        :before-close="closeRecognitionEdit"
        width="540px"
        top="12vh"
        custom-class="recognition-edit-dialog"
        append-to-body>
        <div class="flex-column recognition-edit-body">
          <div class="recognition-edit-header">
            <div class="recognition-edit-title">
              {{ isCreatingRecognitionValue ? 'Create New Value' : 'Edit Value' }}
            </div>
            <div v-if="!isCreatingRecognitionValue" class="recognition-edit-chip-preview">
              <span>{{ currentRecognitionValue.label || '' }}</span>
              <span v-if="popover.langRecognition !== 'EN'" class="recognition-edit-lang-badge">
                {{ currentLanguageName }} translation
              </span>
            </div>
            <div v-else class="recognition-edit-chip-preview recognition-edit-chip-preview--placeholder">
              Add a core value that peers can attach to recognitions
            </div>
          </div>

          <div class="recognition-edit-section">
            <div class="recognition-edit-label">
              <span v-if="popover.langRecognition === 'EN'">Name</span>
              <span v-else>Name · {{ popover.langRecognition }}</span>
            </div>
            <el-input
              :value="recognitionEditNameValue"
              @input="updateRecognitionEditName"
              :placeholder="recognitionEditNamePlaceholder"
              maxlength="60"
              class="recognition-edit-input"
            />
            <div v-if="recognitionEditError" class="recognition-edit-error">
              {{ recognitionEditError }}
            </div>
            <div v-else-if="isCreatingRecognitionValue" class="recognition-edit-help">
              Peers will see this as a #hashtag they can attach to recognitions.
            </div>
            <div v-else-if="popover.langRecognition === 'EN'" class="recognition-edit-help">
              Renaming keeps this value linked to all existing recognitions.
            </div>
            <div v-else class="recognition-edit-help">
              Original: <span class="recognition-edit-reference">{{ currentRecognitionValue.label || '—' }}</span>. Leave blank to show the English name to {{ currentLanguageName }} users.
            </div>
          </div>

          <div class="recognition-edit-section">
            <div class="recognition-edit-label">Description</div>
            <el-input
              v-if="currentRecognitionValue.particular"
              type="textarea"
              :rows="5"
              :maxlength="400"
              show-word-limit
              v-model="currentRecognitionValue.particular.en"
              placeholder="Describe what this value means at your company — e.g. how people demonstrate it, or behaviours to recognise."
              class="recognition-edit-input"
            />
            <div class="recognition-edit-help">
              Used internally for analysis. Not shown to employees. English recommended.
            </div>
          </div>

          <template v-if="!isCreatingRecognitionValue">
            <div class="recognition-edit-divider"></div>

            <div class="recognition-edit-delete-row">
              <div class="recognition-edit-delete-label">Delete this value</div>
              <el-button
                size="small"
                type="danger"
                plain
                icon="el-icon-delete"
                @click="confirmDeleteRecognition">
                Delete value
              </el-button>
            </div>
          </template>

          <div class="recognition-edit-footer">
            <el-button @click="closeRecognitionEdit">Cancel</el-button>
            <el-button type="primary" @click="saveRecognitionEdit">
              {{ isCreatingRecognitionValue ? 'Create value' : 'Done' }}
            </el-button>
          </div>
        </div>
      </el-dialog>

  </div>
</template>

<script>
import format from "date-fns/format";
import firebase from "firebase/app";
import "firebase/database";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
    loadingEven: require("./even/loading").default,
    SettingsToggleRow: require("./even/settings-toggle-row.vue").default,
  },

  name: "settings",
  watch: {
    settingData: {
      handler() {
        this.handlerHeightOfSetting();
      },
      deep: true,
    },
    recognitionValue: {
      handler() {
        this.handlerHeightOfSetting();
      },
      deep: true,
    },
    peerFeedbackExcels: {
      handler() {
        this.handlerHeightOfSetting();
      },
      deep: true,
    },
    async searchmemberandteamandMember() {
      //console.log("searchmemberandteam",this.searchmemberandteamandMember)
      await this.$store.dispatch("settings/searchmemberandteamandMember", {value:this.searchmemberandteamandMember,type:this.addMemberTeamForm.type})
      if(this.addMemberTeamForm.type=='team'){
        this.addMemberTeamForm.team=[]
        for(const key in this.memberInteam){
          const _team=_.find(this.selected_team, { id: key })
          if(_team){
            this.addMemberTeamForm.team.push({key:key,statusClick:true,...this.memberInteam[key]})
          }else{
            this.addMemberTeamForm.team.push({key:key,statusClick:false,...this.memberInteam[key]})
          }
          
        }
      }
      else if(this.addMemberTeamForm.type=='cohort'){
        this.addMemberTeamForm.cohort=[]
        for(const key in this.holidayCohorts){
          const _cohort=_.find(this.selected_cohort,{id:this.holidayCohorts[key].id})
          if(_cohort){
            this.addMemberTeamForm.cohort.push({key:key,statusClick:true,...this.holidayCohorts[key]})
          }else{
            this.addMemberTeamForm.cohort.push({key:key,statusClick:false,...this.holidayCohorts[key]})
          }
        }
      }
      else if(this.addMemberTeamForm.type=='country'){
        this.addMemberTeamForm.country=[]
        for(const key in this.holidayCountries){
          const _country=_.find(this.selected_country,{code:this.holidayCountries[key].code})
          if(_country){
            this.addMemberTeamForm.country.push({key:key,statusClick:true,...this.holidayCountries[key]})
          }else{
            this.addMemberTeamForm.country.push({key:key,statusClick:false,...this.holidayCountries[key]})
          }
        }
      }
      else{
        this.addMemberTeamForm.user=[]
        for(const key in this.member){
           //console.log('this.member',this.member[key])
          const _member=_.find(this.selected_user,{email:this.member[key].email})
          if(_member){
            this.addMemberTeamForm.user.push({key:key,statusClick:true,...this.member[key]})

          }else{
            this.addMemberTeamForm.user.push({key:key,statusClick:false,...this.member[key]})
          }
          
        }
      }
    },
    inputSearch_preset: {
      handler(newVal) {
        //console.log('newVal',newVal)
        this.$store.dispatch("settings/searchData_preset", newVal)
        //this.searchmemberandteam()
      },
      deep: true
    },

    presetForm: {
      handler(newVal) {
        this.checkedChanges_preset()
        
      },
      deep: true 
    },
    showAddAttributeInput: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            if (this.$refs.newAttributeInput) {
              this.$refs.newAttributeInput.focus();
            }
          });
        }
      }
    },
  },
  data() {
    return {
      activeTab: 'general',
      dynamicTags: [
        "Leadership",
        "Initiative",
        "Clarity",
        "Timely",
        "Creativity",
        "Teamwork",
      ],
      recognitionOldValue: [],
      recognitionEditModal: false,
      isCreatingRecognitionValue: false,
      currentRecognitionValue: {},
      recognitionEditError: "",
      uiSetting: {
        medalsForLeaders_checked_row: 0,
        recognitionValue_checked_row: 0,
        peerFeedbackInteractions_checked_row: 0,
      },
      setingChanged: false,
      popover: {
        visibleMedal: false,
        langMedal: "EN",
        visibleRecognition: false,
        langRecognition: "EN",
        visiblePeerFeedback: false,
        langPeerFeedback: "EN",
      },
      recognitionDataSetting: [
        {
          label_th: "test1",
          label_en: "ทดสอบ1",
          id: "test1",
        },
        {
          label_th: "test2_test2",
          label_en: "ทดสอบ2_test2",
          id: "test2",
        },
        {
          label_th: "test3",
          label_en: "ทดสอบ3",
          id: "test3",
        },
      ],
      overdueMonths: [2, 3, 4, 5, 6],
      dayofweek:['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'],
      showModal_holiday_presets: false,
      inputSearch_preset: '',
      status_show_preset_forms:true,
      title_preset:'',
      presetForm:{
        preset_id:'',
        name: '',
        dayoff: [],
        holiday_dates: [],      // Formatted date strings for display
        holiday_dates_val: [],  // Date objects for date picker binding
        company_holiday: true,
        users:[],
        team:[],
        cohorts:[],
        countries:[],
      },
      presetForm_old:{
        preset_id:'',
        name: '',
        dayoff: [],
        holiday_dates: [],
        holiday_dates_val: [],
        company_holiday: true,
        team:[],
        users:[],
        cohorts:[],
        countries:[],
      },
      popup_preset:{
        show:false,
        title:'',
        content:'',
        button_left:'',
        button_right:'',
      },
      presetForm_verify:{
        name:  false,
      },
      addMemberTeam:false,
      addMemberTeamForm:{
        title_left:'',
        type:'',
        title:'',
        description:'',
        team:[],
        user:[],
        cohort:[],
        country:[],
        selected:[],
        placeholder:''
      },
      selected_team:[],
      selected_user:[],
      selected_cohort:[],
      selected_country:[],
      searchmemberandteamandMember:'',
      confirm_add_dialog:false,
      text_confirm:[],
      status_edit_preset:false,
      index_focus:'',
      // townHallThemes: [
      //   { key: 'innovation', name: 'Innovation' },
      //   { key: 'work-life-balance', name: 'Work-Life Balance' },
      //   { key: 'team-building', name: 'Team Building' },
      //   { key: 'problem-solving', name: 'Problem Solving' },
      //   { key: 'communication', name: 'Communication' },
      //   { key: 'leadership', name: 'Leadership' },
      //   { key: 'creativity', name: 'Creativity' },
      //   { key: 'adaptability', name: 'Adaptability' },
      //   { key: 'empathy', name: 'Empathy' },
      //   { key: 'time-management', name: 'Time Management' },
      // ],
      saveTownHallThemeInput: false,
      saveTownHallThemeValue: '',
      peerFeedbackAttributesModal: false,
      isEditingNewTag: false,
      editingAttributeIndex: null,
      currentPeerFeedbackTag: {
        name: '',
        attributes: [],
        key: '',
      },
      newAttributeName: '',
      attributeValidationError: '',
      showAddAttributeInput: false,
      currentAttributeLanguage: 'EN',
      attributeLanguagePopoverVisible: false,
      generatingAttributes: false,
      newTag:false,
    };
  },

  created() {
    // this.$store.dispatch("settings/getoldExcelsByCompany");
    this.$store.dispatch("settings/checkEngOnly", this.user);
    this.$store.dispatch("settings/getDataSetting", this.user);
    this.$store.dispatch("settings/getExcelsByCompany");
    this.$store.dispatch("settings/getoldDataSetting", this.user);
    this.$store.dispatch("member/getMember", this.user);
    this.$store.dispatch("settings/getmemberInteam", this.user);
    //this.oldRecognitionValue = [...this.recognitionValue];
  },
  mounted() {
    this.handlerHeightOfSetting();
    this.handlerHeightOfSetting(1000);
    this.goto();
  },
  computed: {
    feedbackRollupScopeOptions() {
      return [
        {
          value: 'direct',
          label: 'Direct reports only',
          description: 'Each manager sees open-ended feedback only from the people who report directly to them.',
        },
        {
          value: 'default',
          label: 'Direct + one level down (default)',
          description: "Managers also see open-ended feedback from their direct reports' direct reports.",
        },
        {
          value: 'unlimited',
          label: 'Entire management chain',
          description: 'Managers see open-ended feedback from everyone beneath them in the org chart. Expect longer emails for senior leaders.',
        },
      ]
    },
    feedbackRollupScopeDescription() {
      const scope = this.settingData && this.settingData.feedback_rollup_scope
      const match = this.feedbackRollupScopeOptions.find(option => option.value === scope)
      return match ? match.description : ''
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    settingData() {
      return this.$store.getters["settings/setting"];
    },
    countAll() {
      return this.$store.getters["member/countAll"];
    },
    peerFeedbackExcels() {
      return this.$store.getters["settings/excels"];
    },
    hashTagId() {
      return this.$store.getters["settings/hashTagId"];
    },
    settingOldDataMock() {
      return this.$store.getters["settings/settingOldDataMock"];
    },
    oldRecognitionValue() {
      return this.$store.getters["settings/oldRecognitionValue"];
    },
    activeRecognitionLang() {
      return (this.popover.langRecognition || "EN").toLowerCase();
    },
    currentLanguageName() {
      const code = this.popover.langRecognition;
      const match = (this.language || []).find(
        (l) => l.code && l.code.toUpperCase() === code
      );
      return match && match.text ? match.text : code;
    },
    currentPeerFeedbackLanguageName() {
      const code = this.popover.langPeerFeedback;
      const match = (this.language || []).find(
        (l) => l.code && l.code.toUpperCase() === code
      );
      return match && match.text ? match.text : code;
    },
    recognitionEditNameValue() {
      const cur = this.currentRecognitionValue || {};
      if (this.popover.langRecognition === "EN") return cur.label || "";
      return this.hasLangTranslation(cur, this.activeRecognitionLang)
        ? (cur.names || {})[this.activeRecognitionLang]
        : "";
    },
    recognitionEditNamePlaceholder() {
      if (this.popover.langRecognition === "EN") return "e.g. #teamwork";
      return (this.currentRecognitionValue || {}).label || "e.g. #teamwork";
    },
    recognitionValue: {
      get() {
        return this.$store.getters["settings/recognitionValue"];
      },
      set(newValue) {
        this.$store.commit("settings/setRecognitionValue", newValue);
      },
    },
    multiLang() {
      return this.$store.getters["settings/multiLang"];
    },
    oldExcels() {
      return this.$store.getters["settings/oldExcels"];
    },
    language(){
      return this.$store.getters["settings/language"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    member(){
      return this.$store.getters["settings/member"];
    },
    memberInteam(){
      return this.$store.getters["settings/memberinteam"];
    },    
    holidayCohorts(){
      return this.$store.getters["settings/cohortOptions"];
    },
    holidayCountries(){
      return this.$store.getters["settings/countryOptions"];
    },
    presetlist(){
      return this.$store.getters["settings/presetlist"];
    },
    presetlistAll(){
      return this.$store.getters["settings/presetlistAll"];
    },
    loading_preset(){
      return this.$store.getters["settings/loading_preset"];
    },
    townHallThemes() {
      return this.$store.getters["settings/townHallThemes"];
    },
    canSaveNewTag() {
      if (!this.currentPeerFeedbackTag.name ||
          !this.currentPeerFeedbackTag.name.trim() ||
          !this.currentPeerFeedbackTag.attributes ||
          this.currentPeerFeedbackTag.attributes.length !== 6) {
        return false;
      }
      return this.currentPeerFeedbackTag.attributes.every(
        (attr) => attr && attr.text_en && attr.text_en.trim()
      );
    },
    excels_detail(){
      return this.$store.getters["settings/excels_detail"];
    },
    allTeamsSelected() {
      if (!this.addMemberTeamForm.team || this.addMemberTeamForm.team.length === 0) return false;
      return this.addMemberTeamForm.team.every(team => team.statusClick);
    },
    selectedAssignmentCount() {
      if (this.addMemberTeamForm.type === 'team') return this.selected_team.length;
      if (this.addMemberTeamForm.type === 'cohort') return this.selected_cohort.length;
      if (this.addMemberTeamForm.type === 'country') return this.selected_country.length;
      return this.selected_user.length;
    },
    assignmentTypeLabelPlural() {
      if (this.addMemberTeamForm.type === 'team') return 'teams';
      if (this.addMemberTeamForm.type === 'cohort') return 'cohorts';
      if (this.addMemberTeamForm.type === 'country') return 'countries';
      return 'members';
    },
  },
  methods: {
    isRequiredSettingValuePresent(value) {
      return !!String(value || '').replace(/ /g, '')
    },
    getSettingsValidationErrors() {
      const errors = []
      const requiredTextFields = [
        { label: 'Creativity', value: this.settingData.Creativity },
        { label: 'Initiative', value: this.settingData.Initiative },
        { label: 'Kindness', value: this.settingData.Kindness },
        { label: 'Strength', value: this.settingData.Strength },
        { label: 'Charisma', value: this.settingData.Charisma },
        { label: 'Intelligence', value: this.settingData.Intelligence },
      ]

      if (!this.settingData.starttime) errors.push('Check-in start time')
      if (!this.settingData.report_dailyboss_time) errors.push('Daily report time')
      if (!this.settingData.report_weeklyboss_time) errors.push('Weekly report time')
      requiredTextFields.forEach((field) => {
        if (!this.isRequiredSettingValuePresent(field.value)) {
          errors.push(field.label)
        }
      })
      return errors
    },
    toggleDemoMode() {
      this.$store.commit('demomode/changeBlurMode');
    },
    getInitials(firstName, lastName) {
      if (!firstName && !lastName) return '?';
      const first = firstName ? firstName.charAt(0).toUpperCase() : '';
      const last = lastName ? lastName.charAt(0).toUpperCase() : '';
      return first + last || '?';
    },
    getTotalTeamMembers() {
      if (!this.addMemberTeamForm.team) return 0;
      return this.addMemberTeamForm.team.reduce((total, team) => {
        return total + (team.users ? team.users.length : 0);
      }, 0);
    },
    toggleAllTeams() {
      
      if (!this.addMemberTeamForm.team) return;
      
      const allSelected = this.allTeamsSelected;
      
      // Toggle all teams
      this.addMemberTeamForm.team.forEach(team => {
        team.statusClick = !allSelected;
      });
      
      // Update the selected teams array
      if (!allSelected) {
        // Select all teams
        this.selected_team = this.addMemberTeamForm.team.map(team => ({
          id: team.id,
          name: team.name,
          membersteams: team.users ? team.users.length : 0,
          newteam:true
        }));
        
      } else {
        // Deselect all teams
        this.selected_team = [];
      }
    },
    updateCradList(event) {
      this.recognitionValue = this.arrayMovePosition(
        this.recognitionValue,
        event.oldIndex,
        event.newIndex
      );
    },
    arrayMovePosition(arr, old_index, new_index) {
      if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr; // for testing
    },
    goto() {
      const hash = this.$router.currentRoute.hash.split("#")[1];
      var element = this.$refs[hash];
      if (element) {
        const top = element.offsetTop;
        window.scrollTo(0, top + 230);
      }
      if (element) {
        this.$refs[hash].scrollTop = 0 + 230;
      }
    },
    handlerHeightOfSetting(time) {
      let wait = 50;
      if (time) {
        wait = time;
      }
      setTimeout(() => {
        this.checkedChanges();
        this.matchHeight();
      }, wait);
    },
    openPeerFeedbackCreate() {
      const key = firebase.database()
        .ref(`excels_company/${this.user.company}`)
        .push().key;
      this.currentPeerFeedbackTag = {
        name: '',
        name_th: '',
        names: {},
        attributes: [],
        key,
        new_excel: true,
        status_master: false,
      };
      this.isEditingNewTag = true;
      this.newTag = true;
      this.editingAttributeIndex = null;
      this.attributeValidationError = '';
      this.currentAttributeLanguage = 'EN';
      this.peerFeedbackAttributesModal = true;
    },
    stripHashtagPrefix(value) {
      return (value || "").replace(/^#+/, "");
    },
    displayNameFor(value) {
      if (!value) return "";
      if (this.popover.langRecognition === "EN") return value.label || "";
      return this.hasLangTranslation(value, this.activeRecognitionLang)
        ? value.names[this.activeRecognitionLang]
        : (value.label || "");
    },
    hasLangTranslation(value, lang) {
      if (!value || !value.names) return false;
      const t = value.names[lang];
      if (!t || typeof t !== "string") return false;
      const trimmed = t.trim();
      if (!trimmed || trimmed === "#") return false;
      return trimmed !== (value.label || "").trim();
    },
    isCurrentLangUntranslated(value) {
      if (this.popover.langRecognition === "EN") return false;
      return !this.hasLangTranslation(value, this.activeRecognitionLang);
    },
    openRecognitionEdit(value) {
      const clone = _.cloneDeep(value);
      clone.particular = clone.particular || {};
      if (typeof clone.particular.en !== "string") clone.particular.en = "";
      clone.names = clone.names || {};
      this.currentRecognitionValue = clone;
      this.isCreatingRecognitionValue = false;
      this.recognitionEditError = "";
      this.recognitionEditModal = true;
    },
    async openRecognitionCreate() {
      if (this.popover.langRecognition !== "EN") return;
      await this.$store.dispatch("settings/newIdhashtag");
      this.currentRecognitionValue = {
        value: this.hashTagId,
        label: "",
        labelTh: "#",
        names: { en: "" },
        particular: { en: "" },
        order: (this.recognitionValue || []).length + 1,
      };
      this.isCreatingRecognitionValue = true;
      this.recognitionEditError = "";
      this.recognitionEditModal = true;
    },
    closeRecognitionEdit() {
      this.recognitionEditModal = false;
      this.currentRecognitionValue = {};
      this.isCreatingRecognitionValue = false;
      this.recognitionEditError = "";
    },
    updateRecognitionEditName(value) {
      const raw = this.stripHashtagPrefix(value);
      const next = raw ? `#${raw}` : "";
      if (this.popover.langRecognition === "EN") {
        this.$set(this.currentRecognitionValue, "label", next);
        this.$set(this.currentRecognitionValue.names, "en", next);
      } else {
        this.$set(this.currentRecognitionValue.names, this.activeRecognitionLang, next);
      }
      this.recognitionEditError = "";
    },
    saveRecognitionEdit() {
      const mustValidateName =
        this.isCreatingRecognitionValue || this.popover.langRecognition === "EN";
      if (mustValidateName) {
        const label = this.stripHashtagPrefix(this.currentRecognitionValue.label).trim();
        if (!label) {
          this.recognitionEditError = "Name can't be empty.";
          return;
        }
      }
      const recognitionToSave = { ...this.currentRecognitionValue };
      if (this.popover.langRecognition === "EN") {
        recognitionToSave.description =
          (recognitionToSave.particular && recognitionToSave.particular.en) || "";
      }
      if (this.isCreatingRecognitionValue) {
        this.recognitionValue = [
          ...this.recognitionValue,
          recognitionToSave,
        ];
      } else {
        this.recognitionValue = this.recognitionValue.map((v) =>
          v.value === recognitionToSave.value
            ? recognitionToSave
            : v
        );
      }

      this.closeRecognitionEdit();
      this.handlerHeightOfSetting(150);
    },
    confirmDeleteRecognition() {
      const rawName = this.displayNameFor(this.currentRecognitionValue) || this.$t("settings.toast_this_value");
      const name = this.stripHashtagPrefix(rawName);
      this.$confirm(
        `${this.$t("settings.toast_recognition_delete_prefix")} #${name} ${this.$t("settings.toast_recognition_delete_suffix")}`,
        `${this.$t("settings.toast_delete_label")} #${name}?`,
        {
          confirmButtonText: "Delete",
          cancelButtonText: "Keep value",
          type: "warning",
          confirmButtonClass: "el-button--danger",
        }
      )
        .then(() => {
          const id = this.currentRecognitionValue.value;
          this.recognitionValue = this.recognitionValue.filter(
            (v) => v.value !== id
          );
          this.closeRecognitionEdit();
          this.handlerHeightOfSetting(150);
        })
        .catch(() => {});
    },
    removePeerFeedbackTag(id) {
      if (id) {
        let peerFeedbackExcels = {};
        peerFeedbackExcels = this.peerFeedbackExcels.filter((obj) => {
          return obj.key !== id;
        });
        this.$store.commit("settings/setExcels", peerFeedbackExcels);
      }
      this.handlerHeightOfSetting(150);
    },
    skillDisplayNameFor(value) {
      if (!value) return "";
      if (this.popover.langPeerFeedback === "EN") return value.name || "";
      const lang = this.popover.langPeerFeedback.toLowerCase();
      const translated = value.names && value.names[lang];
      if (translated && typeof translated === "string" && translated.trim()) {
        return translated;
      }
      return value.name || "";
    },
    isPeerFeedbackUntranslated(value) {
      if (this.popover.langPeerFeedback === "EN") return false;
      const lang = this.popover.langPeerFeedback.toLowerCase();
      const translated = value && value.names && value.names[lang];
      return !(translated && typeof translated === "string" && translated.trim());
    },
    confirmDeletePeerFeedbackSkill() {
      const tag = this.currentPeerFeedbackTag || {};
      const name = (tag.name || "this skill").trim();
      const isMaster = !!tag.status_master;
      const title = isMaster ? `Disable ${name}?` : `Delete ${name}?`;
      const message = isMaster
        ? `${name} won't be available for new peer feedback at your company. Past feedback keeps its association.`
        : `Any peer feedback that already cited ${name} will lose its association with this skill. This can't be undone.`;
      const confirmText = isMaster ? "Disable" : "Delete";
      this.$confirm(message, title, {
        confirmButtonText: confirmText,
        cancelButtonText: "Keep skill",
        type: "warning",
        confirmButtonClass: "el-button--danger",
      })
        .then(() => {
          this.removePeerFeedbackTag(tag.key);
          this.closePeerFeedbackAttributesModal();
        })
        .catch(() => {});
    },
    saveChanges() {
      const validationErrors = this.getSettingsValidationErrors()
      if (validationErrors.length > 0) {
        this.$message({
          showClose: true,
          message: `${this.$t("settings.toast_valid_data_required")}: ${validationErrors.join(', ')}`,
          type: "error",
        });
      } else {
        var messageLoading = this.$message({
          type: "warning",
          message: this.$t("settings.toast_saving_changes"),
          duration: "9999000",
        });
        this.$store.dispatch("settings/saveChanges", {
          id: this.id,
          form: this.settingData,
          recognitionValue: this.recognitionValue,
          company: this.user.company,
          countMembers: this.countAll,
          thisvue: this,
          messageLoading: messageLoading,
          excels: this.peerFeedbackExcels,
        })
          .then(() => {
            setTimeout(() => {
              this.$store.dispatch("settings/getDataSetting", this.user);
              this.$store.dispatch("settings/getoldDataSetting", this.user);
            }, 1000);
          });
      }
    },
    showDatepickerHoliday() {
      this.$refs.datepicker_holiday.focus();
    },
    showPresetDatepicker() {
      this.$refs.datepicker_preset_holiday.focus();
    },
    confirmPresetHolidayDatepicker() {
      let tag = [];
      let val = [];
      if (
        this.presetForm.holiday_dates_val &&
        this.presetForm.holiday_dates_val.length > 0
      ) {
        let data = _.orderBy(this.presetForm.holiday_dates_val);
        for (const i in data) {
          tag.push(format(data[i], "dddd, MMMM D, YYYY"));
          val.push(data[i]);
        }
      }
      this.presetForm.holiday_dates = tag;
      this.presetForm.holiday_dates_val = val;
    },
    removePresetHolidayDate(index) {
      this.presetForm.holiday_dates.splice(index, 1);
      this.presetForm.holiday_dates_val.splice(index, 1);
    },
    confirmHolidayDatepicker() {
      let tag = [];
      let val = [];
      if (
        this.settingData["holiday_val"] &&
        this.settingData["holiday_val"].length > 0
      ) {
        let data = _.orderBy(this.settingData["holiday_val"]);
        for (const i in data) {
          tag.push(format(data[i], "dddd, MMMM D, YYYY"));
          val.push(data[i]);
        }
      }
      this.settingData["holiday_tag"] = tag;
      this.settingData["holiday_val"] = val;
    },
    removeTag(index) {
      this.settingData["holiday_tag"].splice(index, 1);
      this.settingData["holiday_val"].splice(index, 1);
    },
    getPaddingStyle(data) {
      if (data && data.length > 0) {
        return "12px";
      } else {
        return "20px";
      }
    },
    refresh() {
      localStorage.userVersion = localStorage.appVersion;
      location.reload(true);
      this.goto();
    },
    checkedChanges() {
      const settingData = _.isArray(this.settingOldDataMock) ? true : 
        _.isEqual(this.settingData, this.settingOldDataMock);
      const excels = _.isEqual(this.peerFeedbackExcels, this.oldExcels);
      const recognitionValue = _.isEqual(
        this.recognitionValue,
        this.oldRecognitionValue
      );
      if (!settingData || !recognitionValue || !excels) {
        this.setingChanged = true;
      } else {
        this.setingChanged = false;
      }
    },
    undoSaveSetting() {
      if (this.settingOldDataMock.performance_review) {
        this.pendingAfterChange(_.get(this.settingOldDataMock, "performance_review.pending"));
      }
      this.$store.commit("settings/setDataSetting", this.settingOldDataMock);
      this.$store.commit("settings/setExcels", this.oldExcels);
      this.recognitionValue = [...this.oldRecognitionValue];
      this.$store.dispatch("settings/getDataSetting", this.user);
      this.$store.dispatch("settings/getoldDataSetting", this.user);
      this.$store.dispatch("settings/getExcelsByCompany");
      this.$store.dispatch("settings/getoldExcelsByCompany");
      this.checkedChanges();
    },
    matchHeight() {
      if (this.$refs.medalsForLeaders_checked_row) {
        this.uiSetting.medalsForLeaders_checked_row =
          this.$refs.medalsForLeaders_checked_row.clientHeight;
      }
      if (this.$refs.recognitionValue_checked_row) {
        setTimeout(() => {
          if (this.$refs.recognitionValue_checked_row.clientHeight > 73) {
            this.uiSetting.recognitionValue_checked_row =
              this.$refs.recognitionValue_checked_row.clientHeight;
          } else {
            this.uiSetting.recognitionValue_checked_row = 74;
          }
        }, 100);
      }
      if (this.$refs.peerFeedbackInteractions_checked_row) {
        setTimeout(() => {
          this.uiSetting.peerFeedbackInteractions_checked_row =
            this.$refs.peerFeedbackInteractions_checked_row.clientHeight;
        }, 120);
      }
    },
    setLanguage(value, lang) {
      switch (value) {
        case "medals":
          this.popover.visibleMedal = false;
          this.popover.langMedal = lang;
          break;
        case "recognition":
          this.updateAllContentRecognition();
          this.popover.visibleRecognition = false;
          this.popover.langRecognition = lang;
          break;
        case "peerFeedback":
          this.updateAllContentPeerFeedback();
          this.popover.visiblePeerFeedback = false;
          this.popover.langPeerFeedback = lang;
          break;
      }
      this.handlerHeightOfSetting();
    },
    onInputRecognition(event, index) {
      const labelTh = event.target.innerText;
      this.recognitionValue[index].labelTh = labelTh;
    },
    onRemoveRecognition(index) {
      if (
        this.recognitionValue.length > 1 &&
        this.recognitionValue[index].labelTh.length === 0
      ) {
        this.updateAllContentRecognition();
      }
    },
    updateAllContentRecognition() {
      this.peerFeedbackExcels.forEach((c, index) => {
        const el = document.getElementById(`peerFeedbackExcels-${index}`);
        if (c.labelTh && el) {
          el.innerText = c.labelTh;
        }
      });
    },
    onInputPeerFeedback(event, index) {
      const name_th = event.target.innerText;
      this.peerFeedbackExcels[index].name_th = name_th;
    },
    onRemovePeerFeedback(index) {
      if (
        this.peerFeedbackExcels.length > 1 &&
        this.peerFeedbackExcels[index].name_th.length === 0
      ) {
        this.updateAllContentPeerFeedback();
      }
    },
    updateAllContentPeerFeedback() {
      this.peerFeedbackExcels.forEach((c, index) => {
        const el = document.getElementById(`peerFeedbackExcels-${index}`);
        if (c.name_th && el) {
          el.innerText = c.name_th;
        }
      });
    },
    widthOfBox(text) {
      if (text) {
        if (text.length > 5 && text.length < 80) {
          return "";
        }
      }
      return "display: inline-block;";
    },
    pendingAfterChange(min) {
      this.overdueMonths = _.filter([2, 3, 4, 5, 6], (value) => value > min);
      
      if (min < this.overdueMonths[0]) {
        this.settingData.performance_review.overdue = this.overdueMonths[0];
      }
      if(this.settingData.performance_review.pending!==1){
        this.settingData.performance_review.reset_completed_monthly=false
      }
    },




    createPreset(){
     // console.log('createPreset')
      this.selected_team=[]
      this.selected_user=[]
      this.selected_cohort=[]
      this.selected_country=[]
      this.status_edit_preset=false
      this.title_preset='Create Preset'
      this.status_show_preset_forms = false
      this.createPreset_status = true
      this.presetForm={
        preset_id:'',
        name: '',
        dayoff: [],
        holiday_dates: [],
        holiday_dates_val: [],
        company_holiday: true,
        users:[],
        team:[],
        cohorts:[],
        countries:[],
      }
      this.presetForm_old={
        preset_id:'',
        name: '',
        dayoff: [],
        holiday_dates: [],
        holiday_dates_val: [],
        company_holiday: true,
        users:[],
        team:[],
        cohorts:[],
        countries:[],
      }
      
    },
    closeModalHolidayPresets() {
      this.showModal_holiday_presets = false;
    },
    handleCheckedDayChange(value) {
      this.presetForm.dayoff=value
    },
    openAddMemberTeam(type){
      this.addMemberTeamForm.team=[]
      this.addMemberTeamForm.user=[]
      this.addMemberTeamForm.cohort=[]
      this.addMemberTeamForm.country=[]
      this.addMemberTeam = true
      if(type=='member'){
        this.addMemberTeamForm.type='member'
        this.addMemberTeamForm.title_left='members selected'
        this.addMemberTeamForm.title=`Add members to your ${this.presetForm.name} preset`
        this.addMemberTeamForm.placeholder='Search member name'

        for(const key in this.member){

          const _user=_.find(this.selected_user,function(item){return item.email==key})
          if(_user){ 
            this.addMemberTeamForm.user.push({key:key,statusClick:true,...this.member[key]})
          }else{
            this.addMemberTeamForm.user.push({key:key,statusClick:false,...this.member[key]})
          }
          
        }
        //console.log('addMemberTeamForm',this.addMemberTeamForm)
       
      }else if(type=='team'){
        // console.log('add team',this.memberInteamAll)
        this.addMemberTeamForm.type='team'
        this.addMemberTeamForm.title=`Add teams to your ${this.presetForm.name} preset`
        this.addMemberTeamForm.title_left='teams selected'
        this.addMemberTeamForm.placeholder='Search team name'
        //console.log("key",this.selected_team)
        for(const key in this.memberInteam){
          
          const _team=_.find(this.selected_team,function(item){return item.id==key})
          if(_team){ 
            this.addMemberTeamForm.team.push({key:key,statusClick:true,...this.memberInteam[key]})
          }else{
            this.addMemberTeamForm.team.push({key:key,statusClick:false,...this.memberInteam[key]})
          }
          
        }
        

      }else if(type=='cohort'){
        this.addMemberTeamForm.type='cohort'
        this.addMemberTeamForm.title=`Add cohorts to your ${this.presetForm.name} preset`
        this.addMemberTeamForm.title_left='cohorts selected'
        this.addMemberTeamForm.placeholder='Search cohort name'
        for(const key in this.holidayCohorts){
          const _cohort=_.find(this.selected_cohort,(item)=>{return item.id==this.holidayCohorts[key].id})
          if(_cohort){
            this.addMemberTeamForm.cohort.push({key:key,statusClick:true,...this.holidayCohorts[key]})
          }else{
            this.addMemberTeamForm.cohort.push({key:key,statusClick:false,...this.holidayCohorts[key]})
          }
        }
      }else if(type=='country'){
        this.addMemberTeamForm.type='country'
        this.addMemberTeamForm.title=`Add countries to your ${this.presetForm.name} preset`
        this.addMemberTeamForm.title_left='countries selected'
        this.addMemberTeamForm.placeholder='Search country name'
        for(const key in this.holidayCountries){
          const _country=_.find(this.selected_country,(item)=>{return item.code==this.holidayCountries[key].code})
          if(_country){
            this.addMemberTeamForm.country.push({key:key,statusClick:true,...this.holidayCountries[key]})
          }else{
            this.addMemberTeamForm.country.push({key:key,statusClick:false,...this.holidayCountries[key]})
          }
        }
      }
      //console.log('addMemberTeamForm',this.addMemberTeamForm)
    },
    cancelselectedTeamandMember(){
      //console.log('cancelselectedTeamandMember',this.addMemberTeamForm.type)
      if(this.addMemberTeamForm.type=='team'){
        this.selected_team=this.presetForm&&this.presetForm.team?this.presetForm.team:[]
      }else if(this.addMemberTeamForm.type=='cohort'){
        this.selected_cohort=this.presetForm&&this.presetForm.cohorts?this.presetForm.cohorts:[]
      }else if(this.addMemberTeamForm.type=='country'){
        this.selected_country=this.presetForm&&this.presetForm.countries?this.presetForm.countries:[]
      }else{
        this.selected_user=this.presetForm&&this.presetForm.users?this.presetForm.users:[]
      }
     this.searchmemberandteamandMember=''
      this.addMemberTeam = false
   
    },
    submitselectedTeamandMember(){
      this.checkTeamAndMember()
      this.checkedChanges_preset()
    },
    async deleteUser(email){
      this.presetForm.users= _.filter(this.presetForm.users,(obj)=>{return obj.email!==email})
      this.selected_user=_.filter(this.selected_user,(obj)=>{return obj.email!==email})
      for(const key in this.addMemberTeamForm.user){
        if(email==this.addMemberTeamForm.user[key].email){
          this.addMemberTeamForm.user[key].statusClick=false
        }
      }
      this.checkedChanges_preset()
      this.$forceUpdate()

    },
    deleteTeam(team){
      //console.log('deleteTeam', team)
      this.presetForm.team= _.filter(this.presetForm.team,(obj)=>{return obj.id!==team})
      this.selected_team=_.filter(this.selected_team,(obj)=>{return obj.id!==team})

      for(const key in this.addMemberTeamForm.team){
        if(team==this.addMemberTeamForm.team[key].id){
          this.addMemberTeamForm.team[key].statusClick=false
        }
      }
      this.checkedChanges_preset()
      this.$forceUpdate()
    },
    deleteCohort(cohort){
      this.presetForm.cohorts= _.filter(this.presetForm.cohorts,(obj)=>{return obj.id!==cohort})
      this.selected_cohort=_.filter(this.selected_cohort,(obj)=>{return obj.id!==cohort})

      for(const key in this.addMemberTeamForm.cohort){
        if(cohort==this.addMemberTeamForm.cohort[key].id){
          this.addMemberTeamForm.cohort[key].statusClick=false
        }
      }
      this.checkedChanges_preset()
      this.$forceUpdate()
    },
    deleteCountry(country){
      this.presetForm.countries= _.filter(this.presetForm.countries,(obj)=>{return obj.code!==country})
      this.selected_country=_.filter(this.selected_country,(obj)=>{return obj.code!==country})

      for(const key in this.addMemberTeamForm.country){
        if(country==this.addMemberTeamForm.country[key].code){
          this.addMemberTeamForm.country[key].statusClick=false
        }
      }
      this.checkedChanges_preset()
      this.$forceUpdate()
    },
    checkedChanges_preset() {
      
      const check_preset=_.isEqual(this.presetForm,this.presetForm_old)
      if(!check_preset){
        if(this.createPreset_status){
          this.popup_preset={
          show:true,
          title:'Create new preset',
          content:'',
          status:'create',
          button_left:'Clear',
          button_right:'Save Preset',
          }

        }else {
          this.popup_preset={
          show:true,
          title:'Update your preset',
          content:'',
          status:'update',
          button_left:'Delete',
          button_right:'Save Changes',
          }

        }
        
      }else{
        if(this.status_edit_preset){
          this.popup_preset={
          show:true,
          title:'Update your preset',
          content:'',
          status:'update',
          button_left:'Delete',
          button_right:'',
          }
        }else{
          // console.log('no changes')
        this.popup_preset={
            show:false,
            title:'',
            content:'',
            button_left:'',
            button_right:'',
            }

        }
      
      }
    },
    selectedTeamAndMember(id,type){

      if(type=='team'){
      this.addMemberTeamForm.team[id].statusClick=!this.addMemberTeamForm.team[id].statusClick
      const _find_team=this.selected_team.filter((item)=>{return item.id===this.addMemberTeamForm.team[id].id})
      if(_find_team.length==0){
        this.selected_team.push({membersteams:this.addMemberTeamForm.team[id].users?this.addMemberTeamForm.team[id].users.length:0,name:this.addMemberTeamForm.team[id].name,id:this.addMemberTeamForm.team[id].id,newteam:true})
      }else{
        this.selected_team=this.selected_team.filter((item)=>{return item.id!==this.addMemberTeamForm.team[id].id})
      }
      // this.selected_team=this.addMemberTeamForm.team[id]
      }else if(type=='cohort'){
        this.addMemberTeamForm.cohort[id].statusClick=!this.addMemberTeamForm.cohort[id].statusClick
        const _find_cohort=this.selected_cohort.filter((item)=>{return item.id===this.addMemberTeamForm.cohort[id].id})
        if(_find_cohort.length==0){
          this.selected_cohort.push({id:this.addMemberTeamForm.cohort[id].id,name:this.addMemberTeamForm.cohort[id].name,membercount:this.addMemberTeamForm.cohort[id].membercount || 0,newcohort:true})
        }else{
          this.selected_cohort=this.selected_cohort.filter((item)=>{return item.id!==this.addMemberTeamForm.cohort[id].id})
        }
      }else if(type=='country'){
        this.addMemberTeamForm.country[id].statusClick=!this.addMemberTeamForm.country[id].statusClick
        const _find_country=this.selected_country.filter((item)=>{return item.code===this.addMemberTeamForm.country[id].code})
        if(_find_country.length==0){
          this.selected_country.push({code:this.addMemberTeamForm.country[id].code,id:this.addMemberTeamForm.country[id].code,name:this.addMemberTeamForm.country[id].name,membercount:this.addMemberTeamForm.country[id].membercount || 0,newcountry:true})
        }else{
          this.selected_country=this.selected_country.filter((item)=>{return item.code!==this.addMemberTeamForm.country[id].code})
        }
      }else{       

        this.addMemberTeamForm.user[id].statusClick=!this.addMemberTeamForm.user[id].statusClick
        const _find_user=this.selected_user.filter((item)=>{return item.email===this.addMemberTeamForm.user[id].email})
        if(_find_user.length==0){
          this.selected_user.push({email:this.addMemberTeamForm.user[id].email,firstname  :this.addMemberTeamForm.user[id].firstname,lastname:this.addMemberTeamForm.user[id].lastname,team_name:this.addMemberTeamForm.user[id].team_name,profilepic_crop:this.addMemberTeamForm.user[id]&&this.addMemberTeamForm.user[id].profilepic_crop?this.addMemberTeamForm.user[id].profilepic_crop:'',newuser:true})
        }else{
          this.selected_user=this.selected_user.filter((item)=>{return item.email!==this.addMemberTeamForm.user[id].email})
        }
      }


      this.$forceUpdate()
    },
    async savePreset(){
     // console.log('savePreset')
      //this.verifyPreset()
      // if(this.presetForm_verify.name==true||this.presetForm_verify.goals==true||this.presetForm_verify.culture==true||this.presetForm_verify.next_review==true){
      //   return
      // }else{
        this.$store.dispatch('settings/updateAndCreatePreset',{preset:this.presetForm,duplicate:this.duplicateTeamandMamger})
        this.status_duplicate=false
        this.clearData()

      //}
      
    },
    clearData(){
      this.createPreset_status = false
      this.presetForm={
        preset_id:'',
        name: '',
        dayoff: [],
        holiday_dates: [],
        holiday_dates_val: [],
        company_holiday: true,
        users:[],
        team:[],
        cohorts:[],
        countries:[],
      }
      this.presetForm_old={
        preset_id:'',
        name: '',
        dayoff: [],
        holiday_dates: [],
        holiday_dates_val: [],
        company_holiday: true,
        users:[],
        team:[],
        cohorts:[],
        countries:[],
      }
      this.index_focus=''
      this.selected_team=[]
      this.selected_user=[]
      this.selected_cohort=[]
      this.selected_country=[]
      this.status_edit_preset=false
      this.status_show_preset_forms=true
      this.status_edit_preset=false
    },
    async deletePreset(){
      //console.log('deletePreset')
      this.$store.dispatch('settings/deletePreset',{preset_id:this.presetForm.preset_id})
      this.clearData()
    },
    checkTeamAndMember(){
      //console.log('checkTeamAndMember')
      this.text_confirm=[]
  
      //console.log('checkTeamAndMember',this.presetlistAll)
      const _presetlistAll=_.cloneDeep(this.presetlistAll)
      
      let _presetlistChange=_.cloneDeep(this.presetlistAll)
      if(this.status_duplicate==true){
        _presetlistChange=this.duplicateTeamandMamger
      }

      const duplicateConfig = {
        team: {
          field: 'teams',
          status: 'status_duplicate_team',
          selected: this.selected_team,
          isMatch: (item, value) => item.id === value,
          isNew: (item) => item.newteam,
          label: (item) => `Team "${item.name}"`,
        },
        member: {
          field: 'users',
          status: 'status_duplicate_user',
          selected: this.selected_user,
          isMatch: (item, value) => item.email === value,
          isNew: (item) => item.newuser,
          label: (item) => `Member "${item.firstname} ${item.lastname}"`,
        },
        cohort: {
          field: 'cohorts',
          status: 'status_duplicate_cohort',
          selected: this.selected_cohort,
          isMatch: (item, value) => item.id === value,
          isNew: (item) => item.newcohort,
          label: (item) => `Cohort "${item.name}"`,
        },
        country: {
          field: 'countries',
          status: 'status_duplicate_country',
          selected: this.selected_country,
          isMatch: (item, value) => item.code === value,
          isNew: (item) => item.newcountry,
          label: (item) => `Country "${item.name}"`,
        },
      }
      const config = duplicateConfig[this.addMemberTeamForm.type]
      if(config){
        for(const key in _presetlistAll){
          const kept=[]
          _presetlistChange[key][config.field]=[]
          if(_presetlistAll[key][config.field]){
            for(const target of _presetlistAll[key][config.field]){
              const found=config.selected.filter((item)=>{return config.isMatch(item,target)})
              if(found.length>0){
                if(config.isNew(found[0])){
                  const text=`• ${config.label(found[0])} is currently assigned to "${_presetlistAll[key].name}" preset`
                  this.text_confirm.push(text)
                  _presetlistChange[key][config.status]=true
                  this.status_duplicate=true
                }
              }else{
                kept.push(target)
              }
            }
            if(kept.length>0){
              _presetlistChange[key][config.field]=kept
            }
          }
        }
      }

      this.duplicateTeamandMamger=_presetlistChange
      this.confirm_add_dialog=true
      if(this.text_confirm==''){
        this.confirm_Add()
      }

    },
    handleClose(){
      this.confirm_add_dialog = false
    },
    confirm_Add(){

      if(this.addMemberTeamForm.type=='team'){
        this.presetForm.team=this.selected_team
      }else if(this.addMemberTeamForm.type=='cohort'){
        this.presetForm.cohorts=this.selected_cohort
      }else if(this.addMemberTeamForm.type=='country'){
        this.presetForm.countries=this.selected_country
      }else{
        this.presetForm.users=this.selected_user
      }
      this.addMemberTeam = false
      this.searchmemberandteamandMember=''
      this.confirm_add_dialog = false
      this.checkedChanges_preset()
    },
    getAssignmentSummary(item){
      const teamCount=item.teams?item.teams.length:0
      const cohortCount=item.cohorts?item.cohorts.length:0
      const countryCount=item.countries?item.countries.length:0
      const memberCount=item.users?item.users.length:0
      const parts=[]
      // Audience order: Teams → Cohorts → Countries → Members (matches preset form layout)
      if(teamCount>0) parts.push(`${teamCount} ${teamCount==1?'team':'teams'}`)
      if(cohortCount>0) parts.push(`${cohortCount} ${cohortCount==1?'cohort':'cohorts'}`)
      if(countryCount>0) parts.push(`${countryCount} ${countryCount==1?'country':'countries'}`)
      if(memberCount>0) parts.push(`${memberCount} ${memberCount==1?'member':'members'}`)
      if(parts.length===0) return 'No assignments'
      if(parts.length===1) return `Assigned to ${parts[0]}`
      return parts.join(' · ')
    },
    ClickEditPresets(item){
     // console.log('ClickEditPresets',this.presetlist[item])
      const _presetlist=_.cloneDeep(this.presetlist[item])
      this.title_preset='Edit Preset'
      if(this.index_focus!==''){
        this.presetlist[this.index_focus].focus_preset = false
      }
      const holiday_day=[]
      if(_presetlist.holiday_day){
        for(const key in _presetlist.holiday_day){
          if(_presetlist.holiday_day[key]){
            holiday_day.push(key)
          }
        }
      }
      // Load specific holiday dates
      const holiday_dates = []
      const holiday_dates_val = []
      if (_presetlist.holiday_dates && _presetlist.holiday_dates.length > 0) {
        for (const dateStr of _presetlist.holiday_dates) {
          const dateParts = dateStr.split("-")
          const dateObj = new Date(`${dateParts[0]}/${dateParts[1]}/${dateParts[2]}`)
          holiday_dates.push(format(dateObj, "dddd, MMMM D, YYYY"))
          holiday_dates_val.push(dateObj)
        }
      }
      this.status_edit_preset=true
      this.presetlist[item].focus_preset = true
      this.status_show_preset_forms = false
      this.presetForm.preset_id = _presetlist.id
      this.presetForm.name = _presetlist.name || ''
      this.presetForm.dayoff =holiday_day || []
      this.presetForm.holiday_dates = holiday_dates
      this.presetForm.holiday_dates_val = holiday_dates_val
      this.presetForm.company_holiday = _presetlist.company_holiday || false
      // this.presetForm.goals = _presetlist.goals || ''
      // this.presetForm.culture = _presetlist.culture || ''
      // this.presetForm.next_review =_presetlist.next_review || ''
      this.presetForm.team = _presetlist.team || []
      this.presetForm.users =_presetlist.data_users || []
      this.presetForm.team =_presetlist.data_team || []
      this.presetForm.cohorts =_presetlist.data_cohorts || []
      this.presetForm.countries =_presetlist.data_countries || []
      this.selected_team=_.cloneDeep(this.presetForm.team)
      this.selected_user=_.cloneDeep(this.presetForm.users)
      this.selected_cohort=_.cloneDeep(this.presetForm.cohorts)
      this.selected_country=_.cloneDeep(this.presetForm.countries)
      this.presetForm_old = _.cloneDeep(this.presetForm)
      this.index_focus=item
  
    },
    removeTownHallTheme(key) {
      const townHallThemes = this.townHallThemes.filter(theme => theme.key !== key);
      this.$store.commit('settings/setTownHallThemes', townHallThemes);

      this.$set(this.settingData, 'townhall_themes', townHallThemes);

      this.handlerHeightOfSetting(150);
    },
    showTownHallThemeInput() {
      this.saveTownHallThemeInput = true;
      this.$nextTick((_) => {
        this.$refs.saveTownHallThemeInput.focus();
      });
      this.handlerHeightOfSetting(150);
    },
    handleInputTownHallThemeConfirm() {
      const saveTownHallThemeValue = this.saveTownHallThemeValue.trim();
      if (saveTownHallThemeValue !== "") {
        this.townHallThemes.push({ key: saveTownHallThemeValue.toLowerCase(), name: saveTownHallThemeValue });
        this.saveTownHallThemeValue = '';
        this.saveTownHallThemeInput = false;
        this.handlerHeightOfSetting(150);
      }
    },
    inspectPeerFeedbackTag(value) {
      //console.log('inspectPeerFeedbackTag',value)
      const excels_detail=_.cloneDeep(this.excels_detail[value.key]|| [])
      //console.log('excels_detail',excels_detail)
      //console.log('inspectPeerFeedbackTag')
      // Ensure the tag has the attributes structure
      if (!value.attributes) {
        value.attributes = [];
      }


      this.currentPeerFeedbackTag = {
        ...value,
        attributes: excels_detail
      };
      //console.log('this.currentPeerFeedbackTag',this.currentPeerFeedbackTag)
      this.isEditingNewTag = false;
      this.peerFeedbackAttributesModal = true;

      this.attributeValidationError = '';
    },
    editAttribute(index) {
      this.editingAttributeIndex = index;
    },
    saveAttributeEdit(index) {
      const attribute = this.currentPeerFeedbackTag.attributes[index];
      if (!attribute) {
        this.editingAttributeIndex = null;
        this.attributeValidationError = '';
        return;
      }
      const canonicalKey = this.multiLang ? 'text_en' : `text_${this.currentAttributeLanguage.toLowerCase()}`;
      const canonical = attribute[canonicalKey];
      if (!canonical || !canonical.trim()) {
        this.attributeValidationError = this.multiLang
          ? 'English attribute name is required'
          : 'Attribute name cannot be empty';
        this.$set(attribute, canonicalKey, '');
        this.editingAttributeIndex = index;
        return;
      }
      this.editingAttributeIndex = null;
      this.attributeValidationError = '';
    },
    removeAttribute(index) {
      console.log('removeAttribute',index)
      
      this.currentPeerFeedbackTag.attributes.splice(index, 1);

      this.attributeValidationError = '';
    },
    addAttribute() {
      if (!this.newAttributeName.trim()) {
        this.attributeValidationError = 'Attribute name cannot be empty';
        return;
      }
      
      if (this.currentPeerFeedbackTag.attributes.length >= 6) {
        this.attributeValidationError = 'Maximum 6 attributes allowed';
        return;
      }
      
      // Create attribute with multi-language support
      let newAttribute = {
       text_en: this.newAttributeName.trim()
      };
      
      // If multi-language is enabled, initialize the names object
      if (this.multiLang) {
        newAttribute = {};
        // Create translations for all available languages
        for (const lang of this.language) {
          if (lang.code.toUpperCase() === 'EN') {
            newAttribute[`text_${lang.code.toLowerCase()}`] = this.newAttributeName.trim();
            //newAttribute.names[lang.code.toLowerCase()] = this.newAttributeName.trim();
          } else {
            newAttribute[`text_${lang.code.toLowerCase()}`] = '';
          }
        }
      }
      
      this.currentPeerFeedbackTag.attributes.push(newAttribute);
      this.newAttributeName = '';
      this.showAddAttributeInput = false;
      this.attributeValidationError = '';
    },
    cancelAddAttribute() {
      this.showAddAttributeInput = false;
      this.newAttributeName = '';
      this.attributeValidationError = '';
    },
    async saveNewPeerFeedbackTag() {
      const tag = this.currentPeerFeedbackTag;
      if (!tag.name || !tag.name.trim()) {
        this.attributeValidationError = 'Skill tag name cannot be empty';
        return;
      }
      if (!tag.attributes || tag.attributes.length !== 6) {
        this.attributeValidationError = 'Exactly 6 attributes are required for a new skill tag';
        return;
      }
      if (!tag.attributes.every((attr) => attr && attr.text_en && attr.text_en.trim())) {
        this.attributeValidationError = 'All attributes need an English name';
        return;
      }

      const names = {};
      for (const lang of this.language) {
        names[lang.code] = tag.name;
      }
      tag.names = names;
      tag.name_th = tag.name;
      tag.new_excel = true;

      await this.$store.dispatch('settings/savePeerFeedbackTagChanges', tag);
      this.closePeerFeedbackAttributesModal();
      this.handlerHeightOfSetting(150);
    },
    savePeerFeedbackTagChanges() {
      //console.log('savePeerFeedbackTagChanges')
      // const peerFeedbackExcels = this.peerFeedbackExcels.map(tag =>
      //   tag.key === this.currentPeerFeedbackTag.key ? { 
      //     ...tag, 
      //     attributes: [...this.currentPeerFeedbackTag.attributes],
      //     updated: format(new Date(), "YYYY-MM-DD HH:mm"),
      //   } : tag
      // );
      for(const key in this.currentPeerFeedbackTag.attributes){
        // console.log('key',key)
        // console.log('this.currentPeerFeedbackTag.attributes[key]',this.currentPeerFeedbackTag.attributes[key])
        for (const lang of this.language) {
        // console.log('lang',lang)
        const error=this.validateAttributeName(this.currentPeerFeedbackTag.attributes[key][`text_${lang.code.toLowerCase()}`],lang.code)
        if(error){
          this.attributeValidationError=error
          return
        }
        }

      }
     //console.log('this.currentPeerFeedbackTag',this.currentPeerFeedbackTag)
      this.$store.dispatch('settings/savePeerFeedbackTagChanges',this.currentPeerFeedbackTag)
      this.closePeerFeedbackAttributesModal();
      //this.handlerHeightOfSetting(150);
    },
    closePeerFeedbackAttributesModal() {
      this.peerFeedbackAttributesModal = false;
      this.isEditingNewTag = false;
      this.newTag = false;
      this.editingAttributeIndex = null;
      this.showAddAttributeInput = false;
      this.newAttributeName = '';
      this.attributeValidationError = '';
      this.currentAttributeLanguage = 'EN';
      this.attributeLanguagePopoverVisible = false;
      this.generatingAttributes = false;
      this.currentPeerFeedbackTag = {
        name: '',
        attributes: [],
        key: '',
      };
    },
    showAddAttributeInputField() {
      this.showAddAttributeInput = true;
    },
    getLanguageEmoji(code) {
      const emojiMap = {
        'en': '🇺🇸',
        'th': '🇹🇭',
        'es': '🇪🇸',
        'fr': '🇫🇷',
        'de': '🇩🇪',
        'it': '🇮🇹',
        'pt': '🇵🇹',
        'ru': '🇷🇺',
        'ja': '🇯🇵',
        'ko': '🇰🇷',
        'zh': '🇨🇳',
        'ar': '🇸🇦',
        'hi': '🇮🇳',
        'nl': '🇳🇱',
        'sv': '🇸🇪',
        'no': '🇳🇴',
        'da': '🇩🇰',
        'fi': '🇫🇮',
        'pl': '🇵🇱',
        'tr': '🇹🇷'
      };
      return emojiMap[code.toLowerCase()] || '🌐';
    },
    getCurrentLanguageCode(type) {
      switch (type) {
        case 'recognition':
          return this.popover.langRecognition.toLowerCase();
        case 'peerFeedback':
          return this.popover.langPeerFeedback.toLowerCase();
        default:
          return 'en';
      }
    },
    setAttributeLanguage(lang) {
      this.currentAttributeLanguage = lang;
      this.attributeLanguagePopoverVisible = false;
    },
    getAttributeDisplayName(attribute) {
        // console.log('getAttributeDisplayName')
        // console.log('attribute',attribute)
        // console.log('this.currentAttributeLanguage',this.currentAttributeLanguage)
      const langKey = `text_${this.currentAttributeLanguage.toLowerCase()}`;
      
      // if (!this.multiLang || this.currentAttributeLanguage === 'EN') {
      //   return attribute.name || attribute[langKey] || '';
      // }

      return attribute[langKey]|| `(${this.currentAttributeLanguage} translation missing)`;
    },
    getAttributeEditValue(attribute, index) {
        // console.log('getAttributeEditValue')
        // console.log('attribute',attribute)
        // console.log('index====',index)
      const langKey = `text_${this.currentAttributeLanguage.toLowerCase()}`;
      
      // if (!this.multiLang || this.currentAttributeLanguage === 'EN') {
      //   return attribute.name || attribute[langKey] || '';
      // }
      
      return attribute[langKey] || '';
    },
    updateAttributeNameForLang(index, langCode, value) {
      const attribute = this.currentPeerFeedbackTag.attributes[index];
      if (!attribute) return;
      const langKey = `text_${langCode.toLowerCase()}`;
      this.$set(attribute, langKey, value);
      this.attributeValidationError = '';
    },
    updateAttributeName(index, value) {
        // console.log('updateAttributeName')
        // console.log('value',value)
        // console.log('index',index)
      const attribute = this.currentPeerFeedbackTag.attributes[index];
      // console.log('attribute',attribute)

      const langKey = `text_${this.currentAttributeLanguage.toLowerCase()}`;
      
      // if (!this.multiLang || this.currentAttributeLanguage === 'EN') {
      //   // For English or when multi-language is disabled, update the main name field
      //  // this.$set(attribute, 'name', value);
      //   this.$set(attribute, langKey, value);
      // } else {
      //   // For other languages, update the specific language field
      //   this.$set(attribute, langKey, value);
      // }
      this.$set(attribute, langKey, value);
      // Force reactivity update
      this.$forceUpdate();
    },
    hasTranslation(attribute, langCode) {
      // console.log('hasTranslation')
      // console.log('attribute',attribute)
      // console.log('langCode',langCode)
      if (langCode.toUpperCase() === 'EN') {
        return attribute[`text_${langCode.toLowerCase()}`] && attribute[`text_${langCode.toLowerCase()}`].trim() !== '';
      }
      return attribute[`text_${langCode.toLowerCase()}`] && 
             attribute[`text_${langCode.toLowerCase()}`].trim() !== '';
    },
    async generateAttributesWithAI() {
      if (!this.currentPeerFeedbackTag.name.trim()) {
        this.attributeValidationError = 'Please enter a skill tag name first';
        return;
      }
      this.generatingAttributes = true;
      this.attributeValidationError = '';

      try {
        const skillName = this.currentPeerFeedbackTag.name.trim();
        const result = await this.callAIAttributeGeneration(skillName);

        const extractEntries = (val) => {
          if (Array.isArray(val)) return val;
          if (val && typeof val === 'object') {
            return val.attributes || val.data || val.items || Object.values(val);
          }
          return null;
        };

        let generated = extractEntries(result);
        if (!generated && typeof result === 'string') {
          try {
            generated = extractEntries(JSON.parse(result));
          } catch (e) {
            console.warn('[AI attributes] JSON parse failed, salvaging complete entries', e);
            const salvaged = [];
            const entryRegex = /"\d+"\s*:\s*(\{[^{}]*\})/g;
            let m;
            while ((m = entryRegex.exec(result)) !== null) {
              try {
                salvaged.push(JSON.parse(m[1]));
              } catch (inner) {
                // Skip malformed chunk
              }
            }
            if (salvaged.length > 0) {
              generated = salvaged;
              console.warn(`[AI attributes] salvaged ${salvaged.length} complete entries`);
            }
          }
        }
        if (!Array.isArray(generated)) generated = [];

        const currentCount = (this.currentPeerFeedbackTag.attributes || []).length;
        const availableSlots = Math.max(0, 6 - currentCount);
        const toAdd = generated.slice(0, availableSlots);

        for (const entry of toAdd) {
          const attr = {};
          if (this.multiLang) {
            for (const lang of this.language) {
              const raw = entry && entry[lang.code.toLowerCase()];
              attr[`text_${lang.code.toLowerCase()}`] =
                typeof raw === 'string' ? raw.trim() : '';
            }
          } else {
            const raw = typeof entry === 'string'
              ? entry
              : entry && (entry.en || entry.EN);
            attr.text_en = typeof raw === 'string' ? raw.trim() : '';
          }
          this.currentPeerFeedbackTag.attributes.push(attr);
        }
        this.newTag = false;

        this.$message({
          type: 'success',
          message: `${this.$t("settings.toast_generated_attributes_prefix")} ${toAdd.length} ${this.$t("settings.toast_generated_attributes_middle")} "${skillName}"`,
          duration: 3000,
        });

      } catch (error) {
        console.error('Error generating attributes:', error);
        this.attributeValidationError = this.$t("settings.toast_generate_attributes_failed");

        this.$message({
          type: 'error',
          message: this.$t("settings.toast_generate_attributes_failed"),
          duration: 3000
        });
      } finally {
        this.generatingAttributes = false;
      }
    },
    async callAIAttributeGeneration(skillName) {

      let languages='['
      for(const lang of this.language){
       // console.log('lang',lang)
        languages+=`"${lang.code.toLowerCase()}"`
        if(lang.code.toLowerCase()!==this.language[this.language.length-1].code.toLowerCase()){
          languages+=','
        }
      }
      languages+=']'
      //console.log('languages',languages)
      const value={
        skill:skillName,
        languages:languages
      }
      const result=await this.$store.dispatch('settings/callAIAttributeGeneration',value)
      //console.log('result',result)
      // This is a mock implementation - replace with actual AI API call
      return result
    },
    validateAttributeName(name,lang) {
      
      if (!name.trim()) {
        return `Attribute ${lang.toUpperCase()} cannot be empty`;
      }
      return '';
    }
  }
}
</script>
<style scoped>
.btnAddSettings {
  min-width: 172px;
  height: 52px;
  padding: 0 24px;
  font-size: 18px;
  font-weight: 700;
  border-radius: 8px;
  white-space: nowrap;
}

.btnAddSettings.btnAddSettings--dirty {
  box-shadow: 0 2px 8px rgba(108, 48, 204, 0.25);
}

.div-page-content {
  flex: 1;
}

.inputLabelStyle {
  width: 138px;
  padding-top: 6px;
  color: #4a4a4a;
  font-size: 16px;
  font-weight: 500;
  display: inline-block;
  text-align: right;
}

.inputReportStyle {
  font-size: 18px;
  width: 250px !important;
  margin-left: 12px;
}

.inputReportStyle.red>>>input.el-input__inner {
  border-color: #f44336;
}

.inputMedalStyle {
  font-size: 12px;
  width: 90px;
}

.popup {
  display: none;
  position: absolute;
  min-width: 120px;
  border-radius: 4px;
  padding: 10px 12px;
  background: #ffffff;
  box-shadow: 0px 3px 6px #00000029;
  transition: 0.2s;
}

.input-medal {
  font-size: 12px;
  font-weight: 700;
  color: #454545;
  width: 68px;
  height: 30px;
  padding: 0 10px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #c7c7c7;
  transition: 0.2s;
}

.input-medal:focus-visible,
.input-medal:focus {
  outline: 0;
  border: 1px solid #6c30cc;
}

.input-medal:hover~.popup,
.input-medal:focus~.popup {
  display: block;
}

.recognition-tags:hover~.popup,
.recognition-tags:focus~.popup {
  display: block;
  color: #000;
  background: #fff;
  z-index: 999;
}

.peer-feedback-tags:hover~.popup,
.peer-feedback-tags:focus~.popup {
  display: block;
  color: #000;
  background: #fff;
  z-index: 999;
}

.imgMedal {
  display: block;
  margin: auto;
  width: 72px;
  height: 101.89px;
}

.HolidayTagStyle {
  color: #484848;
  border-width: 1px;
  border-color: #747474;
  background-color: #f7f7f7;
  margin-right: 8px;
  margin-bottom: 8px;
  font-weight: 700;
  font-size: 12px;
  color: #747474;
}

.HolidayTagStyle.el-tag {
  padding: 0px 12px;
}

.el-tag .el-icon-close,
.el-tag .el-icon-close:hover {
  color: #747474;
  background: transparent;
}

.el-input.is-disabled>>>.el-input__inner {
  background-color: #f2f2f2;
  border-color: #c7c7c7;
  color: #747474 !important;
}

#formReport .el-input>>>.el-input__inner {
  color: #3b3b3b;
  font-weight: 400;
  height: 52px;
}

#formReport .el-input--prefix>>>.el-input__icon {
  padding-left: 6px;
}

#formReport .el-input--prefix>>>.el-input__inner {
  padding-left: 140px;
}

#formMedal .el-input>>>.el-input__inner {
  text-align: center;
  color: #454545;
  border-color: #c7c7c7;
  font-weight: 700;
  height: 32px;
  text-overflow: ellipsis;
}

#formMedal .el-input>>>.el-input__inner:focus {
  outline: none;
  border-color: #797979;
}

.el-button--primary {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
}

.el-button--primary:hover,
.el-button--primary:focus {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 0.7;
}

.el-button--primary:active {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 1;
}

.dialogInputDatepicker>>>input.el-input__inner {
  opacity: 0;
  cursor: default;
  padding: 0px;
  height: 33px;
  width: 159px;
}

.dialogInputDatepicker>>>span.el-input__prefix {
  display: none;
}

.btn_AddHolidayStyle {
  position: absolute;
  cursor: pointer;
  width: 159px;
  height: 33px;
  border-radius: 8px;
}

.txt-header {
  width: 170px;
  color: #3b3b3b;
  font-size: 18px;
  font-weight: 700;
  display: inline-block;
  text-align: left;
}

.txt-description {
  color: #4a4a4a;
  font-size: 14px;
}

.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  background: #00acc1;
  border: none;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  margin-top: 10px;
  border-radius: 8px;
}

.button-new-tag:hover {
  background: #00acc1;
  color: #ffffff;
}

.input-new-tag {
  width: 98px;
  vertical-align: bottom;
  margin-top: 10px;
}

.el-tag-peer-feedback {
  background: #00acc1;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  margin-right: 10px;
  margin-top: 10px;
}

.header-text {
  font-size: 18px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 6px;
}

.description-text {
  font-size: 14px;
  color: #4a4a4a;
  width: 740px;
  margin-right: auto;
}

.settings-tab-description {
  max-width: 740px;
  margin: 8px 0 0;
  color: #747078;
  font-size: 14px;
  line-height: 20px;
}

.settings-group-heading {
  color: #747078;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.fair-play-effective-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  box-sizing: border-box;
  width: 100%;
  max-width: 740px;
  padding: 10px 12px;
  color: #5d477f;
  background: rgba(108, 48, 204, 0.06);
  border-left: 3px solid #6c30cc;
  border-radius: 0 6px 6px 0;

  i {
    margin-top: 2px;
  }
}
.modal-1{
    overflow-y: scroll;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 0px 40px 40px 0px;
    opacity: 1;
    height: 84vh;
    min-height: 847px;
    padding-left: 40px;
    max-height: 1200px;
}
.modal-2{
  overflow-y: scroll;
  background: #F8F8F8 0% 0% no-repeat padding-box;
  opacity: 1;
  height: 84vh;
  padding-left: 42px;
  padding-right: 42px;
  min-height: 847px;
  max-height: 1200px;
  position: relative;
}
.btn-preset{
  min-width: 200px;
  height: 33px;
  padding: 0 16px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 8px;
  span span{
    padding: 0px;
  }
}

.key {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  margin: 0 2px;
  background: #FFFFFF;
  border: 1px solid #E4E4E4;
  border-radius: 3px;
  box-shadow: 0 1px 1px rgba(0,0,0,0.1);
  font-size: 12px;
  font-weight: 500;
  color: #4A4A4A;
}

.key + .key {
  margin-left: 2px;
}

/* Peer Feedback Attributes Modal Styles */
.attributes-container {
  max-height: 400px;
  overflow-y: auto;
}

.attribute-item {
  padding: 12px;
  border: 1px solid #E4E4E4;
  border-radius: 4px;
  background: #F8F8F8;
}

.attribute-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #6C30CC;
  color: white;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  margin-right: 12px;
  flex-shrink: 0;
}

.attribute-name {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #2D2E36;
  padding: 8px 0;
}

.attribute-input {
  flex: 1;
  margin-right: 12px;
}

.add-attribute-container {
  margin-top: 16px;
}

.add-attribute-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  border: 2px dashed #C7C7C7;
  border-radius: 4px;
  color: #6C30CC;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s;
}

.add-attribute-btn:hover {
  border-color: #6C30CC;
  background: rgba(108, 48, 204, 0.05);
}

.peer-feedback-tags .el-icon-info {
  opacity: 0.7;
  transition: opacity 0.2s;
}

.peer-feedback-tags:hover .el-icon-info {
  opacity: 1;
}
</style>
<style lang="scss" scoped>
input {
  outline: 0;
}

.input-growup {
  width: 100px;
  outline: 0;
  padding: 4px 28px 4px 12px !important;
  min-height: 19px;

  &:focus {
    border-color: #6c30cc;
  }
}

.span-growup {
  position: absolute;
  left: -9999px;
  display: inline-block;
  min-width: 6em;
}

.setting-row {
  transition: 0.2s;
}

.expand-setting {
  height: 0px;
  overflow: hidden;
}

.recognition-tags {
  font-size: 13px;
  font-weight: 700;
  border: 2px solid #00acc1;
  color: #00acc1;
  border-radius: 30px;
  padding: 5px 12px 3px;
  margin-right: 6px;
  transition: 0.2s;

  &:hover {
    background-color: #00abc118;
  }
}

.recognition-tags~.icon-close {
  right: 18px;
  top: 7px;
  position: absolute;
  color: #00acc1;
}

.recognition-tags.disable {
  opacity: 0.2;
  border: 2px solid #000;
  color: #000;

  &:hover {
    background-color: #fff;
  }
}

.peer-feedback-tags {
  font-size: 15px;
  font-weight: 700;
  border: 2px solid #00acc1;
  background-color: #00acc1;
  color: #fff;
  border-radius: 8px;
  margin-right: 6px;
  padding: 7px 18px 5px 18px;
  transition: 0.2s;

  &:hover {
    background-color: #02a2b8;
  }
}

.peer-feedback-tags~.icon-close {
  right: 18px;
  top: 7px;
  position: absolute;
  color: #fff;
}

.peer-feedback-tags.disable {
  opacity: 0.2;
  border: 2px solid #000;
  background-color: #000;
  color: #fff;

  &:hover {
    background-color: #000;
  }
}

.peer-feedback-chip {
  transition: border-color 0.18s ease, background-color 0.18s ease,
    color 0.18s ease, transform 0.18s ease;
  user-select: none;

  &:hover {
    background-color: #02a2b8;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
}

.peer-feedback-chip--untranslated {
  background-color: #ffffff;
  border: 2px dashed #DCDFE6;
  color: #908D95;
  font-style: italic;
  font-weight: 600;

  &:hover {
    background-color: rgba(0, 172, 193, 0.08);
    border-color: #00acc1;
    color: #00acc1;
  }
}

.peer-feedback-delete-row {
  padding-top: 16px;
  border-top: 1px solid #EEF0F3;
}

.attribute-lang-stack {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.attribute-lang-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.attribute-lang-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background-color: #F5F4F8;
  border-radius: 6px;
  min-width: 60px;
  justify-content: center;

  .flag-mini {
    font-size: 14px;
    line-height: 1;
  }

  .lang-code {
    font-size: 10px;
    font-weight: 700;
    color: #6C30CC;
    letter-spacing: 0.4px;
  }
}

.attribute-lang-input {
  flex: 1;
  min-width: 0;
}

/* Language Selector Styles */
.language-selector-button {
  display: inline-flex;
  align-items: center;
  height: 36px;
  min-width: 80px;
  padding: 0 12px;
  border: 1px solid #E4E4E4;
  border-radius: 6px;
  background: #FFFFFF;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.language-selector-button:hover {
  border-color: #6C30CC;
  box-shadow: 0 2px 8px rgba(108, 48, 204, 0.15);
}

.language-selector-content-btn {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
}

.language-flag-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.language-flag-btn .flag-icon-btn {
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.language-text-btn {
  flex: 1;
  font-size: 13px;
  font-weight: 500;
  color: #2D2E36;
}

.language-arrow {
  font-size: 12px;
  color: #908D95;
  transition: transform 0.2s ease;
}

.language-selector-button:hover .language-arrow {
  color: #6C30CC;
}

.language-arrow.rotated {
  transform: rotate(180deg);
}

.language-selector-content {
  padding: 8px 0;
}

.language-selector-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #908D95;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #F0F0F0;
}

.language-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.language-option:hover {
  background: #F8F6FF;
}

.language-option.active {
  background: #F0EBFF;
  color: #6C30CC;
}

.language-option.active .language-text {
  font-weight: 600;
}

.language-flag {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 3px;
  overflow: hidden;
  background: #F5F5F5;
}

.language-flag .flag-icon {
  font-size: 20px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.language-text {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #2D2E36;
}

.language-check {
  font-size: 16px;
  color: #6C30CC;
  font-weight: 700;
}

/* Translation Status Indicators */
.translation-status {
  margin-left: 36px;
}

.translation-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 10px;
  transition: all 0.2s ease;
}

.translation-indicator.completed {
  background: #E8F5E8;
  color: #4CAF50;
}

.translation-indicator.missing {
  background: #FFF3E0;
  color: #FF9800;
}

.translation-indicator .flag-mini {
  font-size: 12px;
  line-height: 1;
}

.translation-indicator .status-icon {
  font-size: 10px;
}

/* AI Generate Button */
.ai-generate-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  border: none !important;
  border-radius: 6px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  padding: 8px 12px !important;
  height: auto !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3) !important;
}

.ai-generate-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4) !important;
}

.ai-generate-btn:active {
  transform: translateY(0) !important;
}

.ai-generate-btn .el-icon-magic-stick {
  font-size: 14px;
}

/* Preset Date Tags - Custom styling for specific dates */
.preset-date-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #F5EFFF;
  border: 1px solid #D4C4F0;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #4A4A4A;
  transition: all 0.2s ease;
}

.preset-date-tag:hover {
  background: #EEE5FD;
  border-color: #6C30CC;
}

.preset-date-tag .el-icon-close {
  color: #908D95;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.2s ease;
}

.preset-date-tag:hover .el-icon-close {
  color: #6C30CC;
}

.preset-date-tag .date-icon {
  color: #6C30CC;
  font-size: 14px;
}

/* Grid Selection Container */
.grid-selection-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
  max-height: calc(94vh - 240px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
  width: 100%;
}

/* Custom scrollbar for grid container */
.grid-selection-container::-webkit-scrollbar {
  width: 6px;
}

.grid-selection-container::-webkit-scrollbar-track {
  background: #F0F0F0;
  border-radius: 3px;
}

.grid-selection-container::-webkit-scrollbar-thumb {
  background: #C7C7C7;
  border-radius: 3px;
}

.grid-selection-container::-webkit-scrollbar-thumb:hover {
  background: #999;
}

.selection-cell {
  background: #FFFFFF;
  border: 1px solid #E4E4E4;
  border-radius: 4px;
  height: 52px;
  cursor: pointer;
  transition: all 0.2s ease;
  overflow: hidden;
}

.selection-cell:hover {
  border-color: #6C30CC;
  box-shadow: 0 2px 4px rgba(108, 48, 204, 0.1);
}

.selection-cell.border-blue {
  border-color: #6C30CC;
  border-width: 2px;
  background: #F8F6FF;
}

/* Selected team/user items in left panel */
.selected-team-item {
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #E4E4E4;
}

.selected-team-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

/* All Teams Button */
.all-teams-button {
  grid-column: 1 / -1; /* Span across both columns */
  background: #F8F9FA;
  border: 2px dashed #32C2D5;
  border-radius: 6px;
  height: 56px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 12px;
}

.all-teams-button:hover {
  background: #E8F4F8;
  border-style: solid;
  box-shadow: 0 2px 8px rgba(50, 194, 213, 0.15);
  transform: translateY(-1px);
}

.style-bar {
  width: 100%;
  margin-top: 0;
  border: 1px solid #e0e0e0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background: #FFFFFF;
}

.title-bar {
  font-size: 15px;
  color: inherit;
  font-weight: inherit;
}

.recognition-chip {
  font-size: 15px;
  font-weight: 700;
  color: #00acc1;
  background-color: #ffffff;
  border: 2px solid rgba(0, 172, 193, 0.45);
  border-radius: 30px;
  padding: 6px 16px 4px;
  margin-right: 6px;
  transition: border-color 0.18s ease, background-color 0.18s ease, color 0.18s ease, transform 0.18s ease;
  user-select: none;
  white-space: nowrap;

  &:hover {
    border-color: #00acc1;
    background-color: rgba(0, 172, 193, 0.08);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
}

.recognition-chip--untranslated {
  color: #908D95;
  border-color: #DCDFE6;
  border-style: dashed;
  font-style: italic;
  font-weight: 600;

  &:hover {
    color: #6C30CC;
    border-color: #6C30CC;
    background-color: rgba(108, 48, 204, 0.05);
  }
}
</style>
<style lang="scss">
.holiday-preset-dialog {
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__header {
    display: none;
  }
}

.add-member-team-dialog {
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog {
    margin-top: 3vh !important;
  }
}

/* Purple checkbox styling for Holiday Preset modal */
.holiday-preset-dialog .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #6C30CC !important;
  border-color: #6C30CC !important;
}

.holiday-preset-dialog .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #6C30CC !important;
}

.holiday-preset-dialog .el-checkbox__inner:hover {
  border-color: #6C30CC !important;
}

.holiday-preset-dialog .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #6C30CC !important;
}

#settingContainer .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 170px;
  padding: 0;
  font-size: 16px;
  color: #4A4A4A;
  font-weight: 400;
  position: relative;
  text-align: center;
}

#settingContainer .el-tabs__item.is-active {
  color: #6C30CC;
  font-weight: 700;
}

#settingContainer .el-tabs__item:hover {
  color: #6C30CC;
}

#settingContainer .el-tabs__active-bar {
  height: 3px;
  background-color: #6C30CC;
  bottom: 0;
}

#settingContainer .el-tabs__header {
  margin: 0;
  border-bottom: 1px solid #E4E4E4;
}

#settingContainer .el-tabs__nav-wrap::after {
  display: none;
}

#settingContainer .el-tabs__nav {
  margin-left: 20px;
}

#divMedal span.el-switch__core {
  height: 14px;
  width: 27px !important;
  border: none;
}

#divMedal span.el-switch__core::after {
  background: #ffffff;
  width: 10px;
  height: 10px;
  position: absolute;
  margin-top: 1px;
  margin-left: 1px;
}

#divMedal .el-switch.is-checked .el-switch__core::after {
  margin-left: -12px;
  margin-top: 1px;
}

#tagPeer i.el-tag__close.el-icon-close {
  font-size: 16px;
  color: #ffffff;
  font-weight: bold;
}

// .el-tabs__nav-wrap {
//   &::after {
//     display: none;
//   }
// }

// .el-tabs__header {
//   margin: 0;
//   border-bottom: 1px solid #E4E4E4;
// }

// .el-tabs__item {
//   height: 52px;
//   line-height: 52px;
//   padding: 0 20px;
//   font-size: 16px;
//   color: #4A4A4A;
//   font-weight: 400;

//   &.is-active {
//     color: #6C30CC;
//     font-weight: 700;
//   }

//   &:hover {
//     color: #6C30CC;
//   }
// }

// .el-tabs__active-bar {
//   height: 3px;
//   background-color: #6C30CC;
// }

// .el-tabs__nav {
//   padding: 0 20px;
// }

/* Global Language Selector Popover Styles */
.language-selector-popover {
  padding: 0 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid #E4E4E4 !important;
}

.language-selector-popover .el-popover__title {
  display: none !important;
}

.language-selector-popover .popper__arrow {
  border-bottom-color: #FFFFFF !important;
}

.language-selector-popover .popper__arrow::after {
  border-bottom-color: #FFFFFF !important;
}

.recognition-edit-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    padding: 0;
    border-bottom: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .recognition-edit-body {
    padding: 28px;
  }

  .recognition-edit-header {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 24px;
  }

  .recognition-edit-title {
    font-size: 20px;
    font-weight: 700;
    color: #2D2E36;
    line-height: 1.2;
  }

  .recognition-edit-chip-preview {
    font-size: 14px;
    font-weight: 600;
    color: #6C30CC;
    letter-spacing: 0.2px;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .recognition-edit-chip-preview--placeholder {
    color: #908D95;
    font-weight: 500;
    letter-spacing: normal;
  }

  .recognition-edit-lang-badge {
    font-size: 11px;
    font-weight: 700;
    color: #6C30CC;
    background: rgba(108, 48, 204, 0.10);
    border-radius: 999px;
    padding: 3px 10px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
  }

  .recognition-edit-reference {
    color: #6C30CC;
    font-weight: 700;
  }

  .recognition-edit-section {
    margin-bottom: 24px;
  }

  .recognition-edit-label {
    font-size: 13px;
    font-weight: 700;
    color: #2D2E36;
    margin-bottom: 8px;
  }

  .recognition-edit-input .el-input__inner,
  .recognition-edit-input .el-textarea__inner {
    border-radius: 10px;
    border: 1px solid #DCDFE6;
    transition: border-color 0.16s ease, box-shadow 0.16s ease;
    font-size: 14px;
    line-height: 1.55;
  }

  .recognition-edit-input .el-textarea__inner {
    word-break: normal;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    padding: 10px 14px;
    resize: vertical;
  }

  .recognition-edit-input .el-input__count,
  .recognition-edit-input .el-input__count-inner {
    background: transparent;
    color: #908D95;
    font-size: 12px;
  }

  .recognition-edit-input .el-input__inner:focus,
  .recognition-edit-input .el-textarea__inner:focus {
    border-color: #6C30CC;
    box-shadow: 0 0 0 3px rgba(108, 48, 204, 0.08);
  }

  .recognition-edit-help {
    font-size: 12px;
    color: #908D95;
    margin-top: 8px;
    line-height: 1.5;
  }

  .recognition-edit-error {
    font-size: 12px;
    color: #CC3030;
    margin-top: 8px;
  }

  .recognition-edit-divider {
    height: 1px;
    background: #EEF0F3;
    margin: 4px 0 20px;
  }

  .recognition-edit-delete-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 24px;
  }

  .recognition-edit-delete-label {
    font-size: 13px;
    font-weight: 600;
    color: #4A4A4A;
  }

  .recognition-edit-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
}
</style>
